// // import React, { useEffect, useRef, useState, ChangeEvent } from "react";
// // import { useSearchParams, useNavigate } from "react-router-dom";
// // import axios from "axios";
// // import {
// //   FaCheckCircle,
// //   FaExclamationCircle,
// //   FaBuilding,
// //   FaSpinner,
// //   FaTrashAlt,
// //   FaArrowLeft,
// //   FaPhoneAlt,
// //   FaEye,
// //   FaEyeSlash,
// //   FaLock,
// //   FaTimes,
// // } from "react-icons/fa";

// // // --- Config ---
// // const API_URL = process.env.REACT_APP_API_URL!;

// // // --- Worldwide Country/State/City data (top countries with states & major cities) ---
// // const WORLD_DATA: Record<string, Record<string, string[]>> = {
// //   India: {
// //     "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Tirupati"],
// //     "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Pasighat"],
// //     Assam: ["Guwahati", "Silchar", "Dibrugarh", "Jorhat"],
// //     Bihar: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur"],
// //     Chhattisgarh: ["Raipur", "Bhilai", "Korba", "Bilaspur"],
// //     Goa: ["Panaji", "Margao", "Vasco da Gama"],
// //     Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
// //     Haryana: ["Gurugram", "Faridabad", "Ambala", "Hisar"],
// //     "Himachal Pradesh": ["Shimla", "Manali", "Dharamsala", "Solan"],
// //     Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro"],
// //     Karnataka: ["Bengaluru", "Mysuru", "Mangaluru", "Hubballi"],
// //     Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur"],
// //     "Madhya Pradesh": ["Bhopal", "Indore", "Gwalior", "Jabalpur"],
// //     Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"],
// //     Manipur: ["Imphal", "Thoubal", "Bishnupur"],
// //     Meghalaya: ["Shillong", "Tura", "Jowai"],
// //     Mizoram: ["Aizawl", "Lunglei", "Saiha"],
// //     Nagaland: ["Kohima", "Dimapur", "Mokokchung"],
// //     Odisha: ["Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur"],
// //     Punjab: ["Chandigarh", "Ludhiana", "Amritsar", "Jalandhar"],
// //     Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
// //     Sikkim: ["Gangtok", "Namchi", "Gyalshing"],
// //     "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli"],
// //     Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar"],
// //     Tripura: ["Agartala", "Udaipur", "Dharmanagar"],
// //     "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Noida"],
// //     Uttarakhand: ["Dehradun", "Haridwar", "Rishikesh", "Nainital"],
// //     "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Siliguri"],
// //     Delhi: ["New Delhi", "Dwarka", "Rohini", "Saket"],
// //     "Jammu & Kashmir": ["Srinagar", "Jammu", "Anantnag"],
// //     Ladakh: ["Leh", "Kargil"],
// //     Puducherry: ["Puducherry", "Karaikal", "Mahe"],
// //   },
// //   "United States": {
// //     Alabama: ["Birmingham", "Montgomery", "Huntsville", "Mobile"],
// //     Alaska: ["Anchorage", "Fairbanks", "Juneau"],
// //     Arizona: ["Phoenix", "Tucson", "Mesa", "Scottsdale"],
// //     Arkansas: ["Little Rock", "Fort Smith", "Fayetteville"],
// //     California: ["Los Angeles", "San Francisco", "San Diego", "San Jose", "Sacramento"],
// //     Colorado: ["Denver", "Colorado Springs", "Aurora", "Boulder"],
// //     Connecticut: ["Bridgeport", "New Haven", "Hartford", "Stamford"],
// //     Delaware: ["Wilmington", "Dover", "Newark"],
// //     Florida: ["Miami", "Orlando", "Tampa", "Jacksonville", "Tallahassee"],
// //     Georgia: ["Atlanta", "Augusta", "Columbus", "Savannah"],
// //     Hawaii: ["Honolulu", "Pearl City", "Hilo"],
// //     Idaho: ["Boise", "Nampa", "Meridian"],
// //     Illinois: ["Chicago", "Aurora", "Naperville", "Springfield"],
// //     Indiana: ["Indianapolis", "Fort Wayne", "Evansville"],
// //     Iowa: ["Des Moines", "Cedar Rapids", "Davenport"],
// //     Kansas: ["Wichita", "Overland Park", "Kansas City", "Topeka"],
// //     Kentucky: ["Louisville", "Lexington", "Bowling Green"],
// //     Louisiana: ["New Orleans", "Baton Rouge", "Shreveport"],
// //     Maine: ["Portland", "Lewiston", "Bangor"],
// //     Maryland: ["Baltimore", "Frederick", "Rockville", "Annapolis"],
// //     Massachusetts: ["Boston", "Worcester", "Springfield", "Cambridge"],
// //     Michigan: ["Detroit", "Grand Rapids", "Warren", "Ann Arbor"],
// //     Minnesota: ["Minneapolis", "Saint Paul", "Rochester"],
// //     Mississippi: ["Jackson", "Gulfport", "Southaven"],
// //     Missouri: ["Kansas City", "Saint Louis", "Springfield", "Columbia"],
// //     Montana: ["Billings", "Missoula", "Great Falls"],
// //     Nebraska: ["Omaha", "Lincoln", "Bellevue"],
// //     Nevada: ["Las Vegas", "Henderson", "Reno", "Carson City"],
// //     "New Hampshire": ["Manchester", "Nashua", "Concord"],
// //     "New Jersey": ["Newark", "Jersey City", "Paterson", "Trenton"],
// //     "New Mexico": ["Albuquerque", "Las Cruces", "Santa Fe"],
// //     "New York": ["New York City", "Buffalo", "Rochester", "Albany", "Syracuse"],
// //     "North Carolina": ["Charlotte", "Raleigh", "Greensboro", "Durham"],
// //     "North Dakota": ["Fargo", "Bismarck", "Grand Forks"],
// //     Ohio: ["Columbus", "Cleveland", "Cincinnati", "Toledo"],
// //     Oklahoma: ["Oklahoma City", "Tulsa", "Norman"],
// //     Oregon: ["Portland", "Salem", "Eugene"],
// //     Pennsylvania: ["Philadelphia", "Pittsburgh", "Allentown", "Erie"],
// //     "Rhode Island": ["Providence", "Cranston", "Warwick"],
// //     "South Carolina": ["Columbia", "Charleston", "Greenville"],
// //     "South Dakota": ["Sioux Falls", "Rapid City", "Aberdeen"],
// //     Tennessee: ["Nashville", "Memphis", "Knoxville", "Chattanooga"],
// //     Texas: ["Houston", "San Antonio", "Dallas", "Austin", "Fort Worth"],
// //     Utah: ["Salt Lake City", "Provo", "West Valley City"],
// //     Vermont: ["Burlington", "South Burlington", "Rutland"],
// //     Virginia: ["Virginia Beach", "Norfolk", "Chesapeake", "Richmond"],
// //     Washington: ["Seattle", "Spokane", "Tacoma", "Vancouver"],
// //     "West Virginia": ["Charleston", "Huntington", "Morgantown"],
// //     Wisconsin: ["Milwaukee", "Madison", "Green Bay"],
// //     Wyoming: ["Cheyenne", "Casper", "Laramie"],
// //   },
// //   "United Kingdom": {
// //     England: ["London", "Manchester", "Birmingham", "Leeds", "Liverpool", "Sheffield", "Bristol", "Newcastle"],
// //     Scotland: ["Edinburgh", "Glasgow", "Aberdeen", "Dundee", "Inverness"],
// //     Wales: ["Cardiff", "Swansea", "Newport", "Bangor"],
// //     "Northern Ireland": ["Belfast", "Derry", "Lisburn", "Newry"],
// //   },
// //   Canada: {
// //     Ontario: ["Toronto", "Ottawa", "Mississauga", "Hamilton", "Brampton"],
// //     Quebec: ["Montreal", "Quebec City", "Laval", "Gatineau"],
// //     "British Columbia": ["Vancouver", "Victoria", "Kelowna", "Surrey"],
// //     Alberta: ["Calgary", "Edmonton", "Red Deer", "Lethbridge"],
// //     Manitoba: ["Winnipeg", "Brandon", "Steinbach"],
// //     Saskatchewan: ["Saskatoon", "Regina", "Prince Albert"],
// //     "Nova Scotia": ["Halifax", "Dartmouth", "Sydney"],
// //     "New Brunswick": ["Moncton", "Saint John", "Fredericton"],
// //     "Newfoundland and Labrador": ["St. John's", "Corner Brook", "Gander"],
// //     "Prince Edward Island": ["Charlottetown", "Summerside"],
// //   },
// //   Australia: {
// //     "New South Wales": ["Sydney", "Newcastle", "Wollongong", "Canberra"],
// //     Victoria: ["Melbourne", "Geelong", "Ballarat", "Bendigo"],
// //     Queensland: ["Brisbane", "Gold Coast", "Townsville", "Cairns"],
// //     "Western Australia": ["Perth", "Fremantle", "Bunbury"],
// //     "South Australia": ["Adelaide", "Mount Gambier", "Whyalla"],
// //     Tasmania: ["Hobart", "Launceston", "Devonport"],
// //     "Northern Territory": ["Darwin", "Alice Springs"],
// //     "Australian Capital Territory": ["Canberra", "Queanbeyan"],
// //   },
// //   Germany: {
// //     Bavaria: ["Munich", "Nuremberg", "Augsburg", "Regensburg"],
// //     "North Rhine-Westphalia": ["Cologne", "Düsseldorf", "Dortmund", "Essen"],
// //     "Baden-Württemberg": ["Stuttgart", "Karlsruhe", "Mannheim", "Freiburg"],
// //     Berlin: ["Berlin"],
// //     Hamburg: ["Hamburg"],
// //     Hesse: ["Frankfurt", "Wiesbaden", "Kassel"],
// //     Saxony: ["Dresden", "Leipzig", "Chemnitz"],
// //     Brandenburg: ["Potsdam", "Cottbus", "Brandenburg an der Havel"],
// //     "Lower Saxony": ["Hannover", "Braunschweig", "Osnabrück"],
// //     "Rhineland-Palatinate": ["Mainz", "Ludwigshafen", "Koblenz"],
// //   },
// //   France: {
// //     "Île-de-France": ["Paris", "Versailles", "Boulogne-Billancourt"],
// //     "Auvergne-Rhône-Alpes": ["Lyon", "Grenoble", "Clermont-Ferrand", "Saint-Étienne"],
// //     "Provence-Alpes-Côte d'Azur": ["Marseille", "Nice", "Toulon", "Aix-en-Provence"],
// //     "Occitanie": ["Toulouse", "Montpellier", "Nîmes"],
// //     "Nouvelle-Aquitaine": ["Bordeaux", "Limoges", "Pau"],
// //     Bretagne: ["Rennes", "Brest", "Quimper"],
// //     "Pays de la Loire": ["Nantes", "Angers", "Le Mans"],
// //     "Grand Est": ["Strasbourg", "Reims", "Metz"],
// //     "Hauts-de-France": ["Lille", "Amiens", "Roubaix"],
// //     Normandie: ["Rouen", "Caen", "Le Havre"],
// //   },
// //   UAE: {
// //     "Abu Dhabi": ["Abu Dhabi", "Al Ain", "Ruwais"],
// //     Dubai: ["Dubai", "Jebel Ali"],
// //     Sharjah: ["Sharjah", "Khor Fakkan"],
// //     Ajman: ["Ajman"],
// //     "Ras Al Khaimah": ["Ras Al Khaimah"],
// //     Fujairah: ["Fujairah"],
// //     "Umm Al Quwain": ["Umm Al Quwain"],
// //   },
// //   Singapore: {
// //     Singapore: ["Singapore", "Jurong East", "Tampines", "Woodlands", "Punggol"],
// //   },
// //   "New Zealand": {
// //     Auckland: ["Auckland", "Manukau", "North Shore"],
// //     Wellington: ["Wellington", "Lower Hutt", "Porirua"],
// //     Canterbury: ["Christchurch", "Selwyn", "Waimakariri"],
// //     Waikato: ["Hamilton", "Cambridge", "Te Awamutu"],
// //     "Bay of Plenty": ["Tauranga", "Rotorua", "Whakatane"],
// //     Otago: ["Dunedin", "Queenstown", "Alexandra"],
// //   },
// //   "South Africa": {
// //     Gauteng: ["Johannesburg", "Pretoria", "Ekurhuleni"],
// //     "Western Cape": ["Cape Town", "Stellenbosch", "George"],
// //     "KwaZulu-Natal": ["Durban", "Pietermaritzburg", "Richards Bay"],
// //     "Eastern Cape": ["Port Elizabeth", "East London", "Mthatha"],
// //     Limpopo: ["Polokwane", "Tzaneen", "Thohoyandou"],
// //   },
// //   Brazil: {
// //     "São Paulo": ["São Paulo", "Campinas", "Guarulhos", "Santos"],
// //     "Rio de Janeiro": ["Rio de Janeiro", "Niterói", "Nova Iguaçu"],
// //     "Minas Gerais": ["Belo Horizonte", "Uberlândia", "Contagem"],
// //     Bahia: ["Salvador", "Feira de Santana", "Vitória da Conquista"],
// //     Paraná: ["Curitiba", "Londrina", "Maringá"],
// //     "Rio Grande do Sul": ["Porto Alegre", "Caxias do Sul", "Pelotas"],
// //   },
// //   China: {
// //     Beijing: ["Beijing"],
// //     Shanghai: ["Shanghai"],
// //     Guangdong: ["Guangzhou", "Shenzhen", "Dongguan", "Foshan"],
// //     Zhejiang: ["Hangzhou", "Ningbo", "Wenzhou"],
// //     Jiangsu: ["Nanjing", "Suzhou", "Wuxi"],
// //     Sichuan: ["Chengdu", "Mianyang", "Deyang"],
// //     Hubei: ["Wuhan", "Yichang", "Xiangyang"],
// //     Shandong: ["Jinan", "Qingdao", "Yantai"],
// //   },
// //   Japan: {
// //     Tokyo: ["Tokyo", "Shinjuku", "Shibuya", "Harajuku"],
// //     Osaka: ["Osaka", "Sakai", "Suita"],
// //     Kanagawa: ["Yokohama", "Kawasaki", "Sagamihara"],
// //     Aichi: ["Nagoya", "Toyota", "Anjo"],
// //     Hokkaido: ["Sapporo", "Asahikawa", "Hakodate"],
// //     Kyoto: ["Kyoto", "Uji", "Nagaokakyo"],
// //     Fukuoka: ["Fukuoka", "Kitakyushu", "Kurume"],
// //   },
// // };

// // const COUNTRIES = Object.keys(WORLD_DATA).sort();

// // // --- State & Field Configs
// // const initialCompanyState = {
// //   company_name: "",
// //   address: "",
// //   pancard: "",
// //   city: "",
// //   state: "",
// //   country: "",
// //   gst_number: "",
// //   gst_uin: "",       // hidden – default: ""
// //   code: "",           // hidden – default: ""
// //   cin: "",            // hidden – default: ""
// //   email: "",
// //   password: "",       // hidden – default: "company@135"
// //   phone: "",
// //   HSN_SAC: "[]",     // hidden – default: "[]"
// //   GST_SLAB: "[]",   // hidden – default: "[]"
// //   signature: "",
// //   prefix: "",         // hidden – default: ""
// //   postfix: "",        // hidden – default: ""
// //   separatorsign: "", // hidden – default: "/"
// // };

// // type CompanyType = typeof initialCompanyState & { id?: string | number; bank_id?: string | number };

// // // --- Hidden field defaults (sent to API but not shown in UI)
// // const HIDDEN_DEFAULTS = {
// //   password: "",
// //   gst_uin: "",
// //   code: "",
// //   cin: "",
// //   prefix: "",
// //   postfix: "",
// //   separatorsign: "/",
// //   HSN_SAC: "[]",
// //   GST_SLAB: "[]",
// // };

// // // --- Visible field groups
// // const visibleFieldGroups: Array<{
// //   title?: string;
// //   icon?: any;
// //   cols?: string;
// //   fields: Array<any>;
// // }> = [
// //   {
// //     title: "Basic Info",
// //     icon: FaBuilding,
// //     cols: "md:grid-cols-2",
// //     fields: [
// //       {
// //         label: "Company Name",
// //         name: "company_name",
// //         required: true,
// //         icon: <FaBuilding className="inline mr-2 text-blue-700" />,
// //       },
// //       { label: "Address", name: "address", textarea: true, areaRows: 3, gridFull: true },
// //       { label: "Email", name: "email", inputType: "email" },
// //       {
// //         label: "Phone Number",
// //         name: "phone",
// //         inputType: "tel",
// //         icon: <FaPhoneAlt className="inline text-blue-700 mr-2" />,
// //       },
// //     ],
// //   },
// //   {
// //     title: "Registration",
// //     cols: "md:grid-cols-2",
// //     fields: [
// //       { label: "PAN", name: "pancard" },
// //       { label: "GST Number", name: "gst_number" },
// //     ],
// //   },
// // ];

// // // --- AddCompany Component
// // const AddCompany: React.FC = () => {
// //   const [searchParams] = useSearchParams();
// //   const navigate = useNavigate();
// //   const companyId = searchParams.get("company_id");
// //   const isEditMode = companyId && companyId !== "new";

// //   const [company, setCompany] = useState<CompanyType>(initialCompanyState);
// //   const [signatureFile, setSignatureFile] = useState<File | null>(null);
// //   const [signaturePreview, setSignaturePreview] = useState<string>("");
// //   const [loading, setLoading] = useState(false);
// //   const [submitting, setSubmitting] = useState(false);
// //   const [deleteLoading, setDeleteLoading] = useState(false);
// //   const [error, setError] = useState<string>("");
// //   const [formError, setFormError] = useState<string>("");
// //   const [success, setSuccess] = useState<string>("");
// //   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

// //   // Location cascade
// //   const [selectedCountry, setSelectedCountry] = useState("");
// //   const [selectedState, setSelectedState] = useState("");
// //   const [selectedCity, setSelectedCity] = useState("");

// //   const availableStates = selectedCountry ? Object.keys(WORLD_DATA[selectedCountry] || {}).sort() : [];
// //   const availableCities = selectedCountry && selectedState ? (WORLD_DATA[selectedCountry]?.[selectedState] || []).sort() : [];

// //   const alertRef = useRef<HTMLDivElement>(null);

// //   useEffect(() => {
// //     if (error || formError || success) alertRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
// //   }, [error, formError, success]);

// //   // --- Fetch for edit mode
// //   useEffect(() => {
// //     if (isEditMode && companyId) {
// //       setLoading(true);
// //       axios.get(`${API_URL}/companyAuth/company/${companyId}`)
// //         .then((res) => {
// //           setCompany({
// //             ...initialCompanyState,
// //             ...res.data,
// //             password: res.data.password || HIDDEN_DEFAULTS.password,
// //           });
// //           // Set location cascades
// //           const country = res.data.country || "";
// //           const state = res.data.state || "";
// //           const city = res.data.city || "";
// //           setSelectedCountry(country);
// //           setSelectedState(state);
// //           setSelectedCity(city);

// //           if (res.data.signature) {
// //             let url = res.data.signature;
// //             if (typeof url === "string" && url.trim() !== "" && !url.startsWith("http") && !url.startsWith("data:")) {
// //               if (url.startsWith("/")) url = url.substring(1);
// //               const apiBase = (API_URL || "").replace(/\/$/, "");
// //               setSignaturePreview(`${apiBase}/${url}`);
// //             } else {
// //               setSignaturePreview(url);
// //             }
// //           }
// //           setSignatureFile(null);
// //         })
// //         .catch(() => setError("Unable to load company details."))
// //         .finally(() => setLoading(false));
// //     } else {
// //       setCompany(initialCompanyState);
// //       setSelectedCountry("");
// //       setSelectedState("");
// //       setSelectedCity("");
// //       setSignaturePreview("");
// //       setSignatureFile(null);
// //     }
// //     // eslint-disable-next-line
// //   }, [companyId, isEditMode]);

// //   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
// //     const { name, value } = e.target;
// //     setCompany((prev) => ({ ...prev, [name]: value }));
// //   };

// //   const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
// //     const val = e.target.value;
// //     setSelectedCountry(val);
// //     setSelectedState("");
// //     setSelectedCity("");
// //     setCompany((prev) => ({ ...prev, country: val, state: "", city: "" }));
// //   };

// //   const handleStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
// //     const val = e.target.value;
// //     setSelectedState(val);
// //     setSelectedCity("");
// //     setCompany((prev) => ({ ...prev, state: val, city: "" }));
// //   };

// //   const handleCityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
// //     const val = e.target.value;
// //     setSelectedCity(val);
// //     setCompany((prev) => ({ ...prev, city: val }));
// //   };

// //   const handleSignatureChange = (e: ChangeEvent<HTMLInputElement>) => {
// //     const file = e.target.files && e.target.files[0];
// //     if (!file) return;
// //     if (!file.type.match(/^image\/(png|jpeg|jpg|webp|svg\+xml)$/)) {
// //       setFormError("Please upload an image file (png, jpg, jpeg, svg, webp).");
// //       return;
// //     }
// //     setSignatureFile(file);
// //     const reader = new FileReader();
// //     reader.onloadend = () => {
// //       if (reader.result && typeof reader.result === "string") setSignaturePreview(reader.result);
// //     };
// //     reader.readAsDataURL(file);
// //   };

// //   const clearSignature = () => { setSignaturePreview(""); setSignatureFile(null); };

// //   const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
// //   const validatePhone = (phone: string) => /^(\+?\d{1,4}[\s-]?)?\d{10}$/.test(phone);

// //   const handleSubmit = async (e: React.FormEvent) => {
// //     e.preventDefault();
// //     setFormError(""); setSuccess("");

// //     if (!company.company_name.trim()) { setFormError("Company name is required."); return; }
// //     if (company.email && !validateEmail(company.email)) { setFormError("Invalid email address."); return; }
// //     if (company.phone && !validatePhone(company.phone)) { setFormError("Invalid phone number."); return; }

// //     setSubmitting(true);
// //     try {
// //       const formData = new FormData();
// //       // Visible fields
// //       formData.append("company_name", company.company_name);
// //       formData.append("address", company.address);
// //       formData.append("pancard", company.pancard);
// //       formData.append("city", selectedCity || company.city);
// //       formData.append("state", selectedState || company.state);
// //       formData.append("country", selectedCountry || company.country);
// //       formData.append("gst_number", company.gst_number);
// //       formData.append("email", company.email);
// //       formData.append("phone", company.phone);
// //       if (signatureFile) formData.append("signature", signatureFile);

// //       // Hidden fields — always send defaults (or existing value for edit)
// //       formData.append("password", company.password || HIDDEN_DEFAULTS.password);
// //       formData.append("gst_uin", company.gst_uin || HIDDEN_DEFAULTS.gst_uin);
// //       formData.append("code", company.code || HIDDEN_DEFAULTS.code);
// //       formData.append("cin", company.cin || HIDDEN_DEFAULTS.cin);
// //       formData.append("prefix", company.prefix || HIDDEN_DEFAULTS.prefix);
// //       formData.append("postfix", company.postfix || HIDDEN_DEFAULTS.postfix);
// //       formData.append("separatorsign", company.separatorsign || HIDDEN_DEFAULTS.separatorsign);
// //       formData.append("HSN_SAC", company.HSN_SAC || HIDDEN_DEFAULTS.HSN_SAC);
// //       // formData.append("GST_SLAB", company.GST_SLAB || HIDDEN_DEFAULTS.GST_SLAB);

// //       if (isEditMode && companyId) {
// //         const response = await axios.put(
// //           `${API_URL}/companyAuth/company/${companyId}`,
// //           formData,
// //           { headers: { "Content-Type": "multipart/form-data" } }
// //         );
// //         setSuccess("Company updated successfully!");
// //         if (response.data.signature) {
// //           let url = response.data.signature;
// //           if (typeof url === "string" && url.trim() !== "" && !url.startsWith("http") && !url.startsWith("data:")) {
// //             if (url.startsWith("/")) url = url.substring(1);
// //             const apiBase = (API_URL || "").replace(/\/$/, "");
// //             setSignaturePreview(`${apiBase}/${url}`);
// //           } else setSignaturePreview(url);
// //         }
// //       } else {
// //         // Register user first
// //         try {
// //           await axios.post(`${API_URL}/companyAuth/register`, {
// //             name: company.company_name,
// //             email: company.email,
// //             password: company.password || HIDDEN_DEFAULTS.password,
// //             phone: company.phone,
// //             role: "company",
// //           }, { headers: { "Content-Type": "application/json" } });
// //         } catch (err: any) {
// //           setFormError(err.response?.data?.message ? "Registration failed: " + err.response.data.message : "User registration failed");
// //           setSubmitting(false);
// //           return;
// //         }
// //         await axios.post(`${API_URL}/companyAuth/company`, formData, { headers: { "Content-Type": "multipart/form-data" } });
// //         setSuccess("Company added successfully!");
// //         setCompany(initialCompanyState);
// //         setSelectedCountry(""); setSelectedState(""); setSelectedCity("");
// //         setSignaturePreview(""); setSignatureFile(null);
// //       }
// //       setTimeout(() => navigate("/admin/company"), 1200);
// //     } catch (err: any) {
// //       if (err.response?.data?.error) setFormError(err.response.data.error);
// //       else setFormError("Failed to save company.");
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   const handleDelete = async () => {
// //     if (!isEditMode || !companyId) return;
// //     setDeleteLoading(true); setError("");
// //     try {
// //       await axios.delete(`${API_URL}/companyAuth/company/${companyId}`);
// //       setSuccess("Deleted successfully!");
// //       setTimeout(() => navigate("/admin/company"), 900);
// //     } catch { setError("Failed to delete company."); }
// //     finally { setDeleteLoading(false); setShowDeleteConfirm(false); }
// //   };

// //   return (
// //     <div className="bg-white w-full max-w-full 2xl:max-w-[1440px] mx-auto shadow-xl rounded-xl p-4 mt-12 border border-blue-700" style={{ minHeight: "600px" }}>
// //       {/* HEADER */}
// //       <div className="py-6 px-4 md:px-10 flex flex-col sm:flex-row justify-between items-center">
// //         <div className="flex items-center gap-4">
// //           <span className="inline-flex rounded-full bg-blue-100 p-4 shadow">
// //             <FaBuilding className="text-blue-700 text-4xl" />
// //           </span>
// //           <div>
// //             <h2 className="text-3xl font-extrabold text-black leading-tight tracking-tight">
// //               {isEditMode ? "Edit Company" : "Add Company"}
// //             </h2>
// //             <div className="mb-0 text-gray-600 font-medium text-base pt-1 ml-2">
// //               Add or modify your company profile.
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* ALERTS */}
// //       <div className="px-4 md:px-10" ref={alertRef}>
// //         {error && <Alert type="error" message={error} />}
// //         {formError && <Alert type="error" message={formError} />}
// //         {success && <Alert type="success" message={success} />}
// //       </div>

// //       {/* FORM CARD */}
// //       <div className="flex justify-center py-6 pb-16">
// //         <div className="w-full bg-white border border-blue-700 px-4 pt-8 pb-12 md:px-10 md:py-14 rounded-xl shadow-xl relative max-w-full">
// //           {loading ? (
// //             <div className="flex justify-center items-center text-blue-700 font-semibold animate-pulse py-10 text-lg">
// //               <FaSpinner className="animate-spin mr-3 text-2xl" /> Loading company...
// //             </div>
// //           ) : (
// //             <form onSubmit={handleSubmit} className="flex flex-col gap-10" autoComplete="off">

// //               {/* VISIBLE FIELD GROUPS */}
// //               {visibleFieldGroups.map((group, idx) => (
// //                 <fieldset key={idx} className="rounded-lg px-2 py-4 border border-blue-200 bg-white mb-2">
// //                   {group.title && (
// //                     <legend className="font-semibold text-xl mb-4 text-blue-900 flex items-center gap-2 px-2">
// //                       {group.icon && <group.icon />}
// //                       <span>{group.title}</span>
// //                     </legend>
// //                   )}
// //                   <div className={`grid grid-cols-1 ${group.cols || ""} gap-x-8 gap-y-5`}>
// //                     {group.fields.map((fld: any) => (
// //                       <div key={fld.name} className={fld.gridFull ? "col-span-full" : ""}>
// //                         <FormField
// //                           label={fld.label}
// //                           name={fld.name}
// //                           required={fld.required}
// //                           value={company[fld.name as keyof typeof initialCompanyState] as string}
// //                           onChange={handleInputChange}
// //                           textarea={fld.textarea}
// //                           areaRows={fld.areaRows}
// //                           inputType={fld.inputType}
// //                           icon={fld.icon}
// //                         />
// //                       </div>
// //                     ))}
// //                   </div>
// //                 </fieldset>
// //               ))}

// //               {/* LOCATION — Country / State / City cascading dropdowns */}
// //               <fieldset className="rounded-lg px-2 py-4 border border-blue-200 bg-white mb-2">
// //                 <legend className="font-semibold text-xl mb-4 text-blue-900 px-2">Location</legend>
// //                 <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-5">
// //                   {/* Country */}
// //                   <div className="flex flex-col">
// //                     <label className="block font-bold mb-2 text-blue-900 text-lg" htmlFor="country-select">Country</label>
// //                     <select
// //                       id="country-select"
// //                       className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white"
// //                       value={selectedCountry}
// //                       onChange={handleCountryChange}
// //                     >
// //                       <option value="">Select Country</option>
// //                       {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
// //                     </select>
// //                   </div>
// //                   {/* State */}
// //                   <div className="flex flex-col">
// //                     <label className="block font-bold mb-2 text-blue-900 text-lg" htmlFor="state-select">State / Province</label>
// //                     <select
// //                       id="state-select"
// //                       className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white disabled:opacity-50"
// //                       value={selectedState}
// //                       onChange={handleStateChange}
// //                       disabled={!selectedCountry}
// //                     >
// //                       <option value="">{selectedCountry ? "Select State" : "Select Country first"}</option>
// //                       {availableStates.map((s) => <option key={s} value={s}>{s}</option>)}
// //                     </select>
// //                   </div>
// //                   {/* City */}
// //                   <div className="flex flex-col">
// //                     <label className="block font-bold mb-2 text-blue-900 text-lg" htmlFor="city-select">City</label>
// //                     <select
// //                       id="city-select"
// //                       className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white disabled:opacity-50"
// //                       value={selectedCity}
// //                       onChange={handleCityChange}
// //                       disabled={!selectedState}
// //                     >
// //                       <option value="">{selectedState ? "Select City" : "Select State first"}</option>
// //                       {availableCities.map((c) => <option key={c} value={c}>{c}</option>)}
// //                     </select>
// //                   </div>
// //                 </div>
// //               </fieldset>

// //               {/* SIGNATURE UPLOAD */}
// //               <fieldset className="rounded-lg px-2 py-3 border border-blue-200 bg-white mb-2">
// //                 <legend className="font-semibold text-base mb-2 text-blue-700 flex items-center gap-2 px-2 border-0">
// //                   Signature
// //                 </legend>
// //                 <div className="flex flex-col sm:flex-row gap-4 items-center">
// //                   <input
// //                     type="file"
// //                     accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml"
// //                     id="signature"
// //                     name="signature"
// //                     onChange={handleSignatureChange}
// //                     className="block w-full sm:w-auto text-sm file:mr-4 file:py-2 file:px-5 file:rounded-lg file:border-0 file:text-md file:font-semibold file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200 shadow"
// //                   />
// //                   {signaturePreview ? (
// //                     <div className="flex flex-row items-center gap-3">
// //                       <img src={signaturePreview} alt="Signature" className="h-16 w-auto border-2 border-blue-200 bg-white rounded-lg shadow" />
// //                       <button
// //                         type="button"
// //                         aria-label="Remove signature"
// //                         className="ml-1 text-red-600 hover:bg-red-100 border border-red-300 px-3 py-2 rounded-md font-semibold shadow-md"
// //                         onClick={clearSignature}
// //                       >
// //                         <FaTimes className="inline" /> <span className="sr-only md:not-sr-only">Remove</span>
// //                       </button>
// //                     </div>
// //                   ) : (
// //                     <div className="text-xs text-gray-600 mt-1 pl-0.5 font-medium italic">
// //                       Upload your company's authorized signature image (jpg, jpeg, png, svg, webp).
// //                     </div>
// //                   )}
// //                 </div>
// //               </fieldset>

// //               {/* CTA BUTTONS */}
// //               <div className="flex flex-wrap gap-4 pt-6 justify-between items-center">
// //                 <button
// //                   type="submit"
// //                   className="flex items-center gap-3 px-10 py-4 rounded-lg shadow-xl font-black bg-blue-700 text-white text-xl transition active:scale-95 hover:ring-2 hover:ring-blue-300 focus:outline-none"
// //                   disabled={submitting}
// //                 >
// //                   {submitting && <FaSpinner className="animate-spin inline" />}
// //                   {isEditMode
// //                     ? submitting ? "Updating..." : "Update Company"
// //                     : submitting ? "Adding..." : "Add Company"}
// //                 </button>
// //                 <button
// //                   type="button"
// //                   className="bg-white px-8 py-3 rounded-lg border border-blue-700 hover:bg-blue-50 font-bold text-lg text-black transition flex items-center gap-3 shadow"
// //                   onClick={() => navigate("/company")}
// //                   disabled={submitting || deleteLoading}
// //                 >
// //                   <FaArrowLeft className="text-blue-700" /> Cancel
// //                 </button>
// //                 {isEditMode && (
// //                   <button
// //                     type="button"
// //                     className="ml-auto flex items-center px-8 py-3 bg-red-600 text-white rounded-lg font-bold text-lg shadow-xl hover:bg-red-700 transition gap-3"
// //                     onClick={() => setShowDeleteConfirm(true)}
// //                     disabled={deleteLoading}
// //                   >
// //                     <FaTrashAlt />
// //                     {deleteLoading ? "Deleting..." : "Delete"}
// //                   </button>
// //                 )}
// //               </div>
// //             </form>
// //           )}
// //         </div>
// //       </div>

// //       {/* DELETE CONFIRM MODAL */}
// //       {showDeleteConfirm && (
// //         <DeleteConfirm
// //           onConfirm={handleDelete}
// //           onCancel={() => setShowDeleteConfirm(false)}
// //           loading={deleteLoading}
// //           message="Are you sure you want to delete this company?"
// //         />
// //       )}
// //     </div>
// //   );
// // };

// // // --- Alert Component
// // const Alert: React.FC<{ type: "success" | "error"; message: string }> = ({ type, message }) => {
// //   const icon = type === "success"
// //     ? <FaCheckCircle className="mr-2 text-blue-700 text-lg" />
// //     : <FaExclamationCircle className="mr-2 text-red-600 text-lg" />;
// //   const color = type === "success"
// //     ? "bg-blue-100 text-blue-700 border border-blue-300"
// //     : "bg-red-100 text-red-700 border border-red-300";
// //   return (
// //     <div className={`mb-4 rounded-lg px-5 py-3 flex items-center shadow font-bold ${color}`}>
// //       {icon}{message}
// //     </div>
// //   );
// // };

// // // --- FormField Component
// // interface FormFieldProps {
// //   label: string;
// //   name: string;
// //   value: string;
// //   onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
// //   textarea?: boolean;
// //   areaRows?: number;
// //   inputType?: string;
// //   required?: boolean;
// //   icon?: React.ReactNode;
// //   showPasswordToggle?: boolean;
// //   showPassword?: boolean;
// //   setShowPassword?: React.Dispatch<React.SetStateAction<boolean>>;
// // }

// // const FormField: React.FC<FormFieldProps> = ({
// //   label, name, value, onChange,
// //   textarea = false, areaRows = 2,
// //   inputType = "text", required = false,
// //   icon = null, showPasswordToggle, showPassword, setShowPassword,
// // }) => (
// //   <div className="flex flex-col relative group">
// //     <label className="block font-bold mb-2 text-blue-900 flex items-center gap-2 text-lg tracking-tight" htmlFor={name}>
// //       {icon}{label}{required && <span className="text-red-700 ml-1">*</span>}
// //     </label>
// //     {textarea ? (
// //       <textarea
// //         className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 bg-white text-base font-medium resize-none"
// //         id={name} name={name} rows={areaRows} value={value} onChange={onChange}
// //         required={required} spellCheck placeholder={`Enter ${label.toLowerCase()}...`}
// //       />
// //     ) : (
// //       <div className="relative">
// //         <input
// //           className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white pr-12"
// //           id={name} name={name}
// //           type={showPasswordToggle ? (showPassword ? "text" : "password") : inputType}
// //           required={required} value={value} onChange={onChange}
// //           autoComplete={showPasswordToggle || inputType === "password" ? "new-password" : "off"}
// //           placeholder={`Enter ${label.toLowerCase()}${required ? " *" : ""}`}
// //         />
// //         {showPasswordToggle && setShowPassword && (
// //           <button
// //             type="button" aria-label={showPassword ? "Hide password" : "Show password"}
// //             className="absolute right-4 top-1/2 transform -translate-y-1/2 text-blue-700 hover:text-black transition"
// //             tabIndex={-1} onClick={() => setShowPassword((p) => !p)}
// //           >
// //             {showPassword ? <FaEyeSlash /> : <FaEye />}
// //           </button>
// //         )}
// //       </div>
// //     )}
// //     <span className="absolute bottom-0 left-0 w-0 h-1 bg-blue-700 transition-all duration-300 group-focus-within:w-full" />
// //   </div>
// // );

// // // --- Delete Confirm Modal
// // const DeleteConfirm: React.FC<{
// //   onConfirm: () => void; onCancel: () => void; loading: boolean; message?: string;
// // }> = ({ onConfirm, onCancel, loading, message }) => (
// //   <div className="fixed inset-0 flex items-center justify-center z-[120] bg-black/40">
// //     <div className="bg-white p-7 md:p-12 rounded-lg shadow-xl border border-blue-700 relative w-full max-w-xs">
// //       <div className="mb-8 text-2xl font-bold text-red-700 flex items-center gap-2">
// //         <FaExclamationCircle className="text-3xl" />
// //         {message || "Are you sure you want to delete?"}
// //       </div>
// //       <div className="flex gap-3 justify-end">
// //         <button onClick={onCancel} disabled={loading} className="px-6 py-2.5 bg-white border border-blue-700 hover:bg-blue-50 rounded-lg font-bold text-black mr-2 shadow">
// //           Cancel
// //         </button>
// //         <button onClick={onConfirm} disabled={loading} className="px-7 py-2.5 bg-red-600 text-white rounded-lg font-black shadow hover:bg-red-700 transition">
// //           {loading ? <FaSpinner className="animate-spin inline" /> : "Delete"}
// //         </button>
// //       </div>
// //     </div>
// //   </div>
// // );

// // export default AddCompany;

// import React, { useEffect, useRef, useState, ChangeEvent } from "react";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   FaCheckCircle,
//   FaExclamationCircle,
//   FaBuilding,
//   FaSpinner,
//   FaTrashAlt,
//   FaArrowLeft,
//   FaPhoneAlt,
//   FaEye,
//   FaEyeSlash,
//   FaLock,
//   FaTimes,
// } from "react-icons/fa";

// // --- Config ---
// const API_URL = process.env.REACT_APP_API_URL!;

// // --- Worldwide Country/State/City data (top countries with states & major cities) ---
// const WORLD_DATA: Record<string, Record<string, string[]>> = {
//   India: {
//     "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Tirupati"],
//     "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Pasighat"],
//     Assam: ["Guwahati", "Silchar", "Dibrugarh", "Jorhat"],
//     Bihar: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur"],
//     Chhattisgarh: ["Raipur", "Bhilai", "Korba", "Bilaspur"],
//     Goa: ["Panaji", "Margao", "Vasco da Gama"],
//     Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
//     Haryana: ["Gurugram", "Faridabad", "Ambala", "Hisar"],
//     "Himachal Pradesh": ["Shimla", "Manali", "Dharamsala", "Solan"],
//     Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro"],
//     Karnataka: ["Bengaluru", "Mysuru", "Mangaluru", "Hubballi"],
//     Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur"],
//     "Madhya Pradesh": ["Bhopal", "Indore", "Gwalior", "Jabalpur"],
//     Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"],
//     Manipur: ["Imphal", "Thoubal", "Bishnupur"],
//     Meghalaya: ["Shillong", "Tura", "Jowai"],
//     Mizoram: ["Aizawl", "Lunglei", "Saiha"],
//     Nagaland: ["Kohima", "Dimapur", "Mokokchung"],
//     Odisha: ["Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur"],
//     Punjab: ["Chandigarh", "Ludhiana", "Amritsar", "Jalandhar"],
//     Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
//     Sikkim: ["Gangtok", "Namchi", "Gyalshing"],
//     "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli"],
//     Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar"],
//     Tripura: ["Agartala", "Udaipur", "Dharmanagar"],
//     "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Noida"],
//     Uttarakhand: ["Dehradun", "Haridwar", "Rishikesh", "Nainital"],
//     "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Siliguri"],
//     Delhi: ["New Delhi", "Dwarka", "Rohini", "Saket"],
//     "Jammu & Kashmir": ["Srinagar", "Jammu", "Anantnag"],
//     Ladakh: ["Leh", "Kargil"],
//     Puducherry: ["Puducherry", "Karaikal", "Mahe"],
//   },
//   "United States": {
//     Alabama: ["Birmingham", "Montgomery", "Huntsville", "Mobile"],
//     Alaska: ["Anchorage", "Fairbanks", "Juneau"],
//     Arizona: ["Phoenix", "Tucson", "Mesa", "Scottsdale"],
//     Arkansas: ["Little Rock", "Fort Smith", "Fayetteville"],
//     California: ["Los Angeles", "San Francisco", "San Diego", "San Jose", "Sacramento"],
//     Colorado: ["Denver", "Colorado Springs", "Aurora", "Boulder"],
//     Connecticut: ["Bridgeport", "New Haven", "Hartford", "Stamford"],
//     Delaware: ["Wilmington", "Dover", "Newark"],
//     Florida: ["Miami", "Orlando", "Tampa", "Jacksonville", "Tallahassee"],
//     Georgia: ["Atlanta", "Augusta", "Columbus", "Savannah"],
//     Hawaii: ["Honolulu", "Pearl City", "Hilo"],
//     Idaho: ["Boise", "Nampa", "Meridian"],
//     Illinois: ["Chicago", "Aurora", "Naperville", "Springfield"],
//     Indiana: ["Indianapolis", "Fort Wayne", "Evansville"],
//     Iowa: ["Des Moines", "Cedar Rapids", "Davenport"],
//     Kansas: ["Wichita", "Overland Park", "Kansas City", "Topeka"],
//     Kentucky: ["Louisville", "Lexington", "Bowling Green"],
//     Louisiana: ["New Orleans", "Baton Rouge", "Shreveport"],
//     Maine: ["Portland", "Lewiston", "Bangor"],
//     Maryland: ["Baltimore", "Frederick", "Rockville", "Annapolis"],
//     Massachusetts: ["Boston", "Worcester", "Springfield", "Cambridge"],
//     Michigan: ["Detroit", "Grand Rapids", "Warren", "Ann Arbor"],
//     Minnesota: ["Minneapolis", "Saint Paul", "Rochester"],
//     Mississippi: ["Jackson", "Gulfport", "Southaven"],
//     Missouri: ["Kansas City", "Saint Louis", "Springfield", "Columbia"],
//     Montana: ["Billings", "Missoula", "Great Falls"],
//     Nebraska: ["Omaha", "Lincoln", "Bellevue"],
//     Nevada: ["Las Vegas", "Henderson", "Reno", "Carson City"],
//     "New Hampshire": ["Manchester", "Nashua", "Concord"],
//     "New Jersey": ["Newark", "Jersey City", "Paterson", "Trenton"],
//     "New Mexico": ["Albuquerque", "Las Cruces", "Santa Fe"],
//     "New York": ["New York City", "Buffalo", "Rochester", "Albany", "Syracuse"],
//     "North Carolina": ["Charlotte", "Raleigh", "Greensboro", "Durham"],
//     "North Dakota": ["Fargo", "Bismarck", "Grand Forks"],
//     Ohio: ["Columbus", "Cleveland", "Cincinnati", "Toledo"],
//     Oklahoma: ["Oklahoma City", "Tulsa", "Norman"],
//     Oregon: ["Portland", "Salem", "Eugene"],
//     Pennsylvania: ["Philadelphia", "Pittsburgh", "Allentown", "Erie"],
//     "Rhode Island": ["Providence", "Cranston", "Warwick"],
//     "South Carolina": ["Columbia", "Charleston", "Greenville"],
//     "South Dakota": ["Sioux Falls", "Rapid City", "Aberdeen"],
//     Tennessee: ["Nashville", "Memphis", "Knoxville", "Chattanooga"],
//     Texas: ["Houston", "San Antonio", "Dallas", "Austin", "Fort Worth"],
//     Utah: ["Salt Lake City", "Provo", "West Valley City"],
//     Vermont: ["Burlington", "South Burlington", "Rutland"],
//     Virginia: ["Virginia Beach", "Norfolk", "Chesapeake", "Richmond"],
//     Washington: ["Seattle", "Spokane", "Tacoma", "Vancouver"],
//     "West Virginia": ["Charleston", "Huntington", "Morgantown"],
//     Wisconsin: ["Milwaukee", "Madison", "Green Bay"],
//     Wyoming: ["Cheyenne", "Casper", "Laramie"],
//   },
//   "United Kingdom": {
//     England: ["London", "Manchester", "Birmingham", "Leeds", "Liverpool", "Sheffield", "Bristol", "Newcastle"],
//     Scotland: ["Edinburgh", "Glasgow", "Aberdeen", "Dundee", "Inverness"],
//     Wales: ["Cardiff", "Swansea", "Newport", "Bangor"],
//     "Northern Ireland": ["Belfast", "Derry", "Lisburn", "Newry"],
//   },
//   Canada: {
//     Ontario: ["Toronto", "Ottawa", "Mississauga", "Hamilton", "Brampton"],
//     Quebec: ["Montreal", "Quebec City", "Laval", "Gatineau"],
//     "British Columbia": ["Vancouver", "Victoria", "Kelowna", "Surrey"],
//     Alberta: ["Calgary", "Edmonton", "Red Deer", "Lethbridge"],
//     Manitoba: ["Winnipeg", "Brandon", "Steinbach"],
//     Saskatchewan: ["Saskatoon", "Regina", "Prince Albert"],
//     "Nova Scotia": ["Halifax", "Dartmouth", "Sydney"],
//     "New Brunswick": ["Moncton", "Saint John", "Fredericton"],
//     "Newfoundland and Labrador": ["St. John's", "Corner Brook", "Gander"],
//     "Prince Edward Island": ["Charlottetown", "Summerside"],
//   },
//   Australia: {
//     "New South Wales": ["Sydney", "Newcastle", "Wollongong", "Canberra"],
//     Victoria: ["Melbourne", "Geelong", "Ballarat", "Bendigo"],
//     Queensland: ["Brisbane", "Gold Coast", "Townsville", "Cairns"],
//     "Western Australia": ["Perth", "Fremantle", "Bunbury"],
//     "South Australia": ["Adelaide", "Mount Gambier", "Whyalla"],
//     Tasmania: ["Hobart", "Launceston", "Devonport"],
//     "Northern Territory": ["Darwin", "Alice Springs"],
//     "Australian Capital Territory": ["Canberra", "Queanbeyan"],
//   },
//   Germany: {
//     Bavaria: ["Munich", "Nuremberg", "Augsburg", "Regensburg"],
//     "North Rhine-Westphalia": ["Cologne", "Düsseldorf", "Dortmund", "Essen"],
//     "Baden-Württemberg": ["Stuttgart", "Karlsruhe", "Mannheim", "Freiburg"],
//     Berlin: ["Berlin"],
//     Hamburg: ["Hamburg"],
//     Hesse: ["Frankfurt", "Wiesbaden", "Kassel"],
//     Saxony: ["Dresden", "Leipzig", "Chemnitz"],
//     Brandenburg: ["Potsdam", "Cottbus", "Brandenburg an der Havel"],
//     "Lower Saxony": ["Hannover", "Braunschweig", "Osnabrück"],
//     "Rhineland-Palatinate": ["Mainz", "Ludwigshafen", "Koblenz"],
//   },
//   France: {
//     "Île-de-France": ["Paris", "Versailles", "Boulogne-Billancourt"],
//     "Auvergne-Rhône-Alpes": ["Lyon", "Grenoble", "Clermont-Ferrand", "Saint-Étienne"],
//     "Provence-Alpes-Côte d'Azur": ["Marseille", "Nice", "Toulon", "Aix-en-Provence"],
//     "Occitanie": ["Toulouse", "Montpellier", "Nîmes"],
//     "Nouvelle-Aquitaine": ["Bordeaux", "Limoges", "Pau"],
//     Bretagne: ["Rennes", "Brest", "Quimper"],
//     "Pays de la Loire": ["Nantes", "Angers", "Le Mans"],
//     "Grand Est": ["Strasbourg", "Reims", "Metz"],
//     "Hauts-de-France": ["Lille", "Amiens", "Roubaix"],
//     Normandie: ["Rouen", "Caen", "Le Havre"],
//   },
//   UAE: {
//     "Abu Dhabi": ["Abu Dhabi", "Al Ain", "Ruwais"],
//     Dubai: ["Dubai", "Jebel Ali"],
//     Sharjah: ["Sharjah", "Khor Fakkan"],
//     Ajman: ["Ajman"],
//     "Ras Al Khaimah": ["Ras Al Khaimah"],
//     Fujairah: ["Fujairah"],
//     "Umm Al Quwain": ["Umm Al Quwain"],
//   },
//   Singapore: {
//     Singapore: ["Singapore", "Jurong East", "Tampines", "Woodlands", "Punggol"],
//   },
//   "New Zealand": {
//     Auckland: ["Auckland", "Manukau", "North Shore"],
//     Wellington: ["Wellington", "Lower Hutt", "Porirua"],
//     Canterbury: ["Christchurch", "Selwyn", "Waimakariri"],
//     Waikato: ["Hamilton", "Cambridge", "Te Awamutu"],
//     "Bay of Plenty": ["Tauranga", "Rotorua", "Whakatane"],
//     Otago: ["Dunedin", "Queenstown", "Alexandra"],
//   },
//   "South Africa": {
//     Gauteng: ["Johannesburg", "Pretoria", "Ekurhuleni"],
//     "Western Cape": ["Cape Town", "Stellenbosch", "George"],
//     "KwaZulu-Natal": ["Durban", "Pietermaritzburg", "Richards Bay"],
//     "Eastern Cape": ["Port Elizabeth", "East London", "Mthatha"],
//     Limpopo: ["Polokwane", "Tzaneen", "Thohoyandou"],
//   },
//   Brazil: {
//     "São Paulo": ["São Paulo", "Campinas", "Guarulhos", "Santos"],
//     "Rio de Janeiro": ["Rio de Janeiro", "Niterói", "Nova Iguaçu"],
//     "Minas Gerais": ["Belo Horizonte", "Uberlândia", "Contagem"],
//     Bahia: ["Salvador", "Feira de Santana", "Vitória da Conquista"],
//     Paraná: ["Curitiba", "Londrina", "Maringá"],
//     "Rio Grande do Sul": ["Porto Alegre", "Caxias do Sul", "Pelotas"],
//   },
//   China: {
//     Beijing: ["Beijing"],
//     Shanghai: ["Shanghai"],
//     Guangdong: ["Guangzhou", "Shenzhen", "Dongguan", "Foshan"],
//     Zhejiang: ["Hangzhou", "Ningbo", "Wenzhou"],
//     Jiangsu: ["Nanjing", "Suzhou", "Wuxi"],
//     Sichuan: ["Chengdu", "Mianyang", "Deyang"],
//     Hubei: ["Wuhan", "Yichang", "Xiangyang"],
//     Shandong: ["Jinan", "Qingdao", "Yantai"],
//   },
//   Japan: {
//     Tokyo: ["Tokyo", "Shinjuku", "Shibuya", "Harajuku"],
//     Osaka: ["Osaka", "Sakai", "Suita"],
//     Kanagawa: ["Yokohama", "Kawasaki", "Sagamihara"],
//     Aichi: ["Nagoya", "Toyota", "Anjo"],
//     Hokkaido: ["Sapporo", "Asahikawa", "Hakodate"],
//     Kyoto: ["Kyoto", "Uji", "Nagaokakyo"],
//     Fukuoka: ["Fukuoka", "Kitakyushu", "Kurume"],
//   },
// };

// const COUNTRIES = Object.keys(WORLD_DATA).sort();

// // --- State & Field Configs
// const initialCompanyState = {
//   company_name: "",
//   address: "",
//   pancard: "",
//   city: "",
//   state: "",
//   country: "",
//   gst_number: "",
//   gst_uin: "",
//   code: "",
//   cin: "",
//   email: "",
//   password: "",
//   phone: "",
//   HSN_SAC: "[]",
//   GST_SLAB: "[]",
//   signature: "",
//   prefix: "",
//   postfix: "",
//   separatorsign: "",
// };

// type CompanyType = typeof initialCompanyState & { id?: string | number; bank_id?: string | number };

// // --- Hidden field defaults (sent to API but not shown in UI)
// const HIDDEN_DEFAULTS = {
//   password: "",
//   gst_uin: "",
//   code: "",
//   cin: "",
//   prefix: "",
//   postfix: "",
//   separatorsign: "/",
//   HSN_SAC: "[]",
//   GST_SLAB: "[]",
// };

// // ✅ Helper: coerce null / undefined / "null" / "undefined" to empty string
// const sanitize = (value: unknown, fallback = ""): string => {
//   if (value === null || value === undefined) return fallback;
//   const str = String(value);
//   if (str === "null" || str === "undefined") return fallback;
//   return str;
// };

// // --- Visible field groups
// const visibleFieldGroups: Array<{
//   title?: string;
//   icon?: any;
//   cols?: string;
//   fields: Array<any>;
// }> = [
//   {
//     title: "Basic Info",
//     icon: FaBuilding,
//     cols: "md:grid-cols-2",
//     fields: [
//       {
//         label: "Company Name",
//         name: "company_name",
//         required: true,
//         icon: <FaBuilding className="inline mr-2 text-blue-700" />,
//       },
//       { label: "Address", name: "address", textarea: true, areaRows: 3, gridFull: true },
//       { label: "Email", name: "email", inputType: "email" },
//       {
//         label: "Phone Number",
//         name: "phone",
//         inputType: "tel",
//         icon: <FaPhoneAlt className="inline text-blue-700 mr-2" />,
//       },
//     ],
//   },
//   {
//     title: "Registration",
//     cols: "md:grid-cols-2",
//     fields: [
//       { label: "PAN", name: "pancard" },
//       { label: "GST Number", name: "gst_number" },
//     ],
//   },
// ];

// // --- AddCompany Component
// const AddCompany: React.FC = () => {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const companyId = searchParams.get("company_id");
//   const isEditMode = companyId && companyId !== "new";

//   const [company, setCompany] = useState<CompanyType>(initialCompanyState);
//   const [signatureFile, setSignatureFile] = useState<File | null>(null);
//   const [signaturePreview, setSignaturePreview] = useState<string>("");
//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [error, setError] = useState<string>("");
//   const [formError, setFormError] = useState<string>("");
//   const [success, setSuccess] = useState<string>("");
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

//   // Location cascade
//   const [selectedCountry, setSelectedCountry] = useState("");
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedCity, setSelectedCity] = useState("");

//   const availableStates = selectedCountry ? Object.keys(WORLD_DATA[selectedCountry] || {}).sort() : [];
//   const availableCities = selectedCountry && selectedState ? (WORLD_DATA[selectedCountry]?.[selectedState] || []).sort() : [];

//   const alertRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     if (error || formError || success) alertRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//   }, [error, formError, success]);

//   // --- Fetch for edit mode
//   useEffect(() => {
//     if (isEditMode && companyId) {
//       setLoading(true);
//       axios.get(`${API_URL}/companyAuth/company/${companyId}`)
//         .then((res) => {
//           const data = res.data;

//           // ✅ Sanitize every field coming from the API so nulls never bleed into FormData
//           const sanitized: CompanyType = {
//             ...initialCompanyState,
//             company_name:   sanitize(data.company_name),
//             address:        sanitize(data.address),
//             pancard:        sanitize(data.pancard),
//             city:           sanitize(data.city),
//             state:          sanitize(data.state),
//             country:        sanitize(data.country),
//             gst_number:     sanitize(data.gst_number),
//             gst_uin:        sanitize(data.gst_uin,        HIDDEN_DEFAULTS.gst_uin),
//             code:           sanitize(data.code,           HIDDEN_DEFAULTS.code),
//             cin:            sanitize(data.cin,            HIDDEN_DEFAULTS.cin),
//             email:          sanitize(data.email),
//             password:       sanitize(data.password,       HIDDEN_DEFAULTS.password),
//             phone:          sanitize(data.phone),
//             HSN_SAC:        sanitize(data.HSN_SAC,        HIDDEN_DEFAULTS.HSN_SAC),
//             GST_SLAB:       sanitize(data.GST_SLAB,       HIDDEN_DEFAULTS.GST_SLAB),
//             signature:      sanitize(data.signature),
//             prefix:         sanitize(data.prefix,         HIDDEN_DEFAULTS.prefix),
//             postfix:        sanitize(data.postfix,        HIDDEN_DEFAULTS.postfix),
//             separatorsign:  sanitize(data.separatorsign,  HIDDEN_DEFAULTS.separatorsign),
//             id:             data.id,
//             bank_id:        data.bank_id,
//           };

//           setCompany(sanitized);

//           // Set location cascades
//           setSelectedCountry(sanitized.country);
//           setSelectedState(sanitized.state);
//           setSelectedCity(sanitized.city);

//           if (sanitized.signature) {
//             let url = sanitized.signature;
//             if (!url.startsWith("http") && !url.startsWith("data:")) {
//               if (url.startsWith("/")) url = url.substring(1);
//               const apiBase = (API_URL || "").replace(/\/$/, "");
//               setSignaturePreview(`${apiBase}/${url}`);
//             } else {
//               setSignaturePreview(url);
//             }
//           }
//           setSignatureFile(null);
//         })
//         .catch(() => setError("Unable to load company details."))
//         .finally(() => setLoading(false));
//     } else {
//       setCompany(initialCompanyState);
//       setSelectedCountry("");
//       setSelectedState("");
//       setSelectedCity("");
//       setSignaturePreview("");
//       setSignatureFile(null);
//     }
//     // eslint-disable-next-line
//   }, [companyId, isEditMode]);

//   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//     const { name, value } = e.target;
//     setCompany((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     const val = e.target.value;
//     setSelectedCountry(val);
//     setSelectedState("");
//     setSelectedCity("");
//     setCompany((prev) => ({ ...prev, country: val, state: "", city: "" }));
//   };

//   const handleStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     const val = e.target.value;
//     setSelectedState(val);
//     setSelectedCity("");
//     setCompany((prev) => ({ ...prev, state: val, city: "" }));
//   };

//   const handleCityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     const val = e.target.value;
//     setSelectedCity(val);
//     setCompany((prev) => ({ ...prev, city: val }));
//   };

//   const handleSignatureChange = (e: ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files && e.target.files[0];
//     if (!file) return;
//     if (!file.type.match(/^image\/(png|jpeg|jpg|webp|svg\+xml)$/)) {
//       setFormError("Please upload an image file (png, jpg, jpeg, svg, webp).");
//       return;
//     }
//     setSignatureFile(file);
//     const reader = new FileReader();
//     reader.onloadend = () => {
//       if (reader.result && typeof reader.result === "string") setSignaturePreview(reader.result);
//     };
//     reader.readAsDataURL(file);
//   };

//   const clearSignature = () => { setSignaturePreview(""); setSignatureFile(null); };

//   const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//   const validatePhone = (phone: string) => /^(\+?\d{1,4}[\s-]?)?\d{10}$/.test(phone);

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     setFormError(""); setSuccess("");

//     if (!company.company_name.trim()) { setFormError("Company name is required."); return; }
//     if (company.email && !validateEmail(company.email)) { setFormError("Invalid email address."); return; }
//     if (company.phone && !validatePhone(company.phone)) { setFormError("Invalid phone number."); return; }

//     setSubmitting(true);
//     try {
//       const formData = new FormData();

//       // ✅ All appends go through sanitize() so null/undefined never become the string "null"
//       formData.append("company_name", sanitize(company.company_name));
//       formData.append("address",      sanitize(company.address));
//       formData.append("pancard",      sanitize(company.pancard));
//       formData.append("city",         sanitize(selectedCity    || company.city));
//       formData.append("state",        sanitize(selectedState   || company.state));
//       formData.append("country",      sanitize(selectedCountry || company.country));
//       formData.append("gst_number",   sanitize(company.gst_number));
//       formData.append("email",        sanitize(company.email));
//       formData.append("phone",        sanitize(company.phone));
//       if (signatureFile) formData.append("signature", signatureFile);

//       // Hidden fields
//       formData.append("password",      sanitize(company.password,      HIDDEN_DEFAULTS.password));
//       formData.append("gst_uin",       sanitize(company.gst_uin,       HIDDEN_DEFAULTS.gst_uin));
//       formData.append("code",          sanitize(company.code,          HIDDEN_DEFAULTS.code));
//       formData.append("cin",           sanitize(company.cin,           HIDDEN_DEFAULTS.cin));
//       formData.append("prefix",        sanitize(company.prefix,        HIDDEN_DEFAULTS.prefix));
//       formData.append("postfix",       sanitize(company.postfix,       HIDDEN_DEFAULTS.postfix));
//       formData.append("separatorsign", sanitize(company.separatorsign, HIDDEN_DEFAULTS.separatorsign));
//       formData.append("HSN_SAC",       sanitize(company.HSN_SAC,       HIDDEN_DEFAULTS.HSN_SAC));

//       if (isEditMode && companyId) {
//         const response = await axios.put(
//           `${API_URL}/companyAuth/company/${companyId}`,
//           formData,
//           { headers: { "Content-Type": "multipart/form-data" } }
//         );
//         setSuccess("Company updated successfully!");
//         if (response.data.signature) {
//           let url = sanitize(response.data.signature);
//           if (url && !url.startsWith("http") && !url.startsWith("data:")) {
//             if (url.startsWith("/")) url = url.substring(1);
//             const apiBase = (API_URL || "").replace(/\/$/, "");
//             setSignaturePreview(`${apiBase}/${url}`);
//           } else setSignaturePreview(url);
//         }
//       } else {
//         // Register user first
//         try {
//           await axios.post(`${API_URL}/companyAuth/register`, {
//             name:     sanitize(company.company_name),
//             email:    sanitize(company.email),
//             password: sanitize(company.password, HIDDEN_DEFAULTS.password),
//             phone:    sanitize(company.phone),
//             role: "company",
//           }, { headers: { "Content-Type": "application/json" } });
//         } catch (err: any) {
//           setFormError(err.response?.data?.message ? "Registration failed: " + err.response.data.message : "User registration failed");
//           setSubmitting(false);
//           return;
//         }
//         await axios.post(`${API_URL}/companyAuth/company`, formData, { headers: { "Content-Type": "multipart/form-data" } });
//         setSuccess("Company added successfully!");
//         setCompany(initialCompanyState);
//         setSelectedCountry(""); setSelectedState(""); setSelectedCity("");
//         setSignaturePreview(""); setSignatureFile(null);
//       }
//       setTimeout(() => navigate("/admin/company"), 1200);
//     } catch (err: any) {
//       if (err.response?.data?.error) setFormError(err.response.data.error);
//       else setFormError("Failed to save company.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleDelete = async () => {
//     if (!isEditMode || !companyId) return;
//     setDeleteLoading(true); setError("");
//     try {
//       await axios.delete(`${API_URL}/companyAuth/company/${companyId}`);
//       setSuccess("Deleted successfully!");
//       setTimeout(() => navigate("/admin/company"), 900);
//     } catch { setError("Failed to delete company."); }
//     finally { setDeleteLoading(false); setShowDeleteConfirm(false); }
//   };

//   return (
//     <div className="bg-white w-full max-w-full 2xl:max-w-[1440px] mx-auto shadow-xl rounded-xl p-4 mt-12 border border-blue-700" style={{ minHeight: "600px" }}>
//       {/* HEADER */}
//       <div className="py-6 px-4 md:px-10 flex flex-col sm:flex-row justify-between items-center">
//         <div className="flex items-center gap-4">
//           <span className="inline-flex rounded-full bg-blue-100 p-4 shadow">
//             <FaBuilding className="text-blue-700 text-4xl" />
//           </span>
//           <div>
//             <h2 className="text-3xl font-extrabold text-black leading-tight tracking-tight">
//               {isEditMode ? "Edit Company" : "Add Company"}
//             </h2>
//             <div className="mb-0 text-gray-600 font-medium text-base pt-1 ml-2">
//               Add or modify your company profile.
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ALERTS */}
//       <div className="px-4 md:px-10" ref={alertRef}>
//         {error && <Alert type="error" message={error} />}
//         {formError && <Alert type="error" message={formError} />}
//         {success && <Alert type="success" message={success} />}
//       </div>

//       {/* FORM CARD */}
//       <div className="flex justify-center py-6 pb-16">
//         <div className="w-full bg-white border border-blue-700 px-4 pt-8 pb-12 md:px-10 md:py-14 rounded-xl shadow-xl relative max-w-full">
//           {loading ? (
//             <div className="flex justify-center items-center text-blue-700 font-semibold animate-pulse py-10 text-lg">
//               <FaSpinner className="animate-spin mr-3 text-2xl" /> Loading company...
//             </div>
//           ) : (
//             <form onSubmit={handleSubmit} className="flex flex-col gap-10" autoComplete="off">

//               {/* VISIBLE FIELD GROUPS */}
//               {visibleFieldGroups.map((group, idx) => (
//                 <fieldset key={idx} className="rounded-lg px-2 py-4 border border-blue-200 bg-white mb-2">
//                   {group.title && (
//                     <legend className="font-semibold text-xl mb-4 text-blue-900 flex items-center gap-2 px-2">
//                       {group.icon && <group.icon />}
//                       <span>{group.title}</span>
//                     </legend>
//                   )}
//                   <div className={`grid grid-cols-1 ${group.cols || ""} gap-x-8 gap-y-5`}>
//                     {group.fields.map((fld: any) => (
//                       <div key={fld.name} className={fld.gridFull ? "col-span-full" : ""}>
//                         <FormField
//                           label={fld.label}
//                           name={fld.name}
//                           required={fld.required}
//                           value={company[fld.name as keyof typeof initialCompanyState] as string}
//                           onChange={handleInputChange}
//                           textarea={fld.textarea}
//                           areaRows={fld.areaRows}
//                           inputType={fld.inputType}
//                           icon={fld.icon}
//                         />
//                       </div>
//                     ))}
//                   </div>
//                 </fieldset>
//               ))}

//               {/* LOCATION — Country / State / City cascading dropdowns */}
//               <fieldset className="rounded-lg px-2 py-4 border border-blue-200 bg-white mb-2">
//                 <legend className="font-semibold text-xl mb-4 text-blue-900 px-2">Location</legend>
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-5">
//                   {/* Country */}
//                   <div className="flex flex-col">
//                     <label className="block font-bold mb-2 text-blue-900 text-lg" htmlFor="country-select">Country</label>
//                     <select
//                       id="country-select"
//                       className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white"
//                       value={selectedCountry}
//                       onChange={handleCountryChange}
//                     >
//                       <option value="">Select Country</option>
//                       {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
//                     </select>
//                   </div>
//                   {/* State */}
//                   <div className="flex flex-col">
//                     <label className="block font-bold mb-2 text-blue-900 text-lg" htmlFor="state-select">State / Province</label>
//                     <select
//                       id="state-select"
//                       className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white disabled:opacity-50"
//                       value={selectedState}
//                       onChange={handleStateChange}
//                       disabled={!selectedCountry}
//                     >
//                       <option value="">{selectedCountry ? "Select State" : "Select Country first"}</option>
//                       {availableStates.map((s) => <option key={s} value={s}>{s}</option>)}
//                     </select>
//                   </div>
//                   {/* City */}
//                   <div className="flex flex-col">
//                     <label className="block font-bold mb-2 text-blue-900 text-lg" htmlFor="city-select">City</label>
//                     <select
//                       id="city-select"
//                       className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white disabled:opacity-50"
//                       value={selectedCity}
//                       onChange={handleCityChange}
//                       disabled={!selectedState}
//                     >
//                       <option value="">{selectedState ? "Select City" : "Select State first"}</option>
//                       {availableCities.map((c) => <option key={c} value={c}>{c}</option>)}
//                     </select>
//                   </div>
//                 </div>
//               </fieldset>

//               {/* SIGNATURE UPLOAD */}
//               <fieldset className="rounded-lg px-2 py-3 border border-blue-200 bg-white mb-2">
//                 <legend className="font-semibold text-base mb-2 text-blue-700 flex items-center gap-2 px-2 border-0">
//                   Signature
//                 </legend>
//                 <div className="flex flex-col sm:flex-row gap-4 items-center">
//                   <input
//                     type="file"
//                     accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml"
//                     id="signature"
//                     name="signature"
//                     onChange={handleSignatureChange}
//                     className="block w-full sm:w-auto text-sm file:mr-4 file:py-2 file:px-5 file:rounded-lg file:border-0 file:text-md file:font-semibold file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200 shadow"
//                   />
//                   {signaturePreview ? (
//                     <div className="flex flex-row items-center gap-3">
//                       <img src={signaturePreview} alt="Signature" className="h-16 w-auto border-2 border-blue-200 bg-white rounded-lg shadow" />
//                       <button
//                         type="button"
//                         aria-label="Remove signature"
//                         className="ml-1 text-red-600 hover:bg-red-100 border border-red-300 px-3 py-2 rounded-md font-semibold shadow-md"
//                         onClick={clearSignature}
//                       >
//                         <FaTimes className="inline" /> <span className="sr-only md:not-sr-only">Remove</span>
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="text-xs text-gray-600 mt-1 pl-0.5 font-medium italic">
//                       Upload your company's authorized signature image (jpg, jpeg, png, svg, webp).
//                     </div>
//                   )}
//                 </div>
//               </fieldset>

//               {/* CTA BUTTONS */}
//               <div className="flex flex-wrap gap-4 pt-6 justify-between items-center">
//                 <button
//                   type="submit"
//                   className="flex items-center gap-3 px-10 py-4 rounded-lg shadow-xl font-black bg-blue-700 text-white text-xl transition active:scale-95 hover:ring-2 hover:ring-blue-300 focus:outline-none"
//                   disabled={submitting}
//                 >
//                   {submitting && <FaSpinner className="animate-spin inline" />}
//                   {isEditMode
//                     ? submitting ? "Updating..." : "Update Company"
//                     : submitting ? "Adding..." : "Add Company"}
//                 </button>
//                 <button
//                   type="button"
//                   className="bg-white px-8 py-3 rounded-lg border border-blue-700 hover:bg-blue-50 font-bold text-lg text-black transition flex items-center gap-3 shadow"
//                   onClick={() => navigate("/admin/company")}
//                   disabled={submitting || deleteLoading}
//                 >
//                   <FaArrowLeft className="text-blue-700" /> Cancel
//                 </button>
//                 {isEditMode && (
//                   <button
//                     type="button"
//                     className="ml-auto flex items-center px-8 py-3 bg-red-600 text-white rounded-lg font-bold text-lg shadow-xl hover:bg-red-700 transition gap-3"
//                     onClick={() => setShowDeleteConfirm(true)}
//                     disabled={deleteLoading}
//                   >
//                     <FaTrashAlt />
//                     {deleteLoading ? "Deleting..." : "Delete"}
//                   </button>
//                 )}
//               </div>
//             </form>
//           )}
//         </div>
//       </div>

//       {/* DELETE CONFIRM MODAL */}
//       {showDeleteConfirm && (
//         <DeleteConfirm
//           onConfirm={handleDelete}
//           onCancel={() => setShowDeleteConfirm(false)}
//           loading={deleteLoading}
//           message="Are you sure you want to delete this company?"
//         />
//       )}
//     </div>
//   );
// };

// // --- Alert Component
// const Alert: React.FC<{ type: "success" | "error"; message: string }> = ({ type, message }) => {
//   const icon = type === "success"
//     ? <FaCheckCircle className="mr-2 text-blue-700 text-lg" />
//     : <FaExclamationCircle className="mr-2 text-red-600 text-lg" />;
//   const color = type === "success"
//     ? "bg-blue-100 text-blue-700 border border-blue-300"
//     : "bg-red-100 text-red-700 border border-red-300";
//   return (
//     <div className={`mb-4 rounded-lg px-5 py-3 flex items-center shadow font-bold ${color}`}>
//       {icon}{message}
//     </div>
//   );
// };

// // --- FormField Component
// interface FormFieldProps {
//   label: string;
//   name: string;
//   value: string;
//   onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
//   textarea?: boolean;
//   areaRows?: number;
//   inputType?: string;
//   required?: boolean;
//   icon?: React.ReactNode;
//   showPasswordToggle?: boolean;
//   showPassword?: boolean;
//   setShowPassword?: React.Dispatch<React.SetStateAction<boolean>>;
// }

// const FormField: React.FC<FormFieldProps> = ({
//   label, name, value, onChange,
//   textarea = false, areaRows = 2,
//   inputType = "text", required = false,
//   icon = null, showPasswordToggle, showPassword, setShowPassword,
// }) => (
//   <div className="flex flex-col relative group">
//     <label className="block font-bold mb-2 text-blue-900 flex items-center gap-2 text-lg tracking-tight" htmlFor={name}>
//       {icon}{label}{required && <span className="text-red-700 ml-1">*</span>}
//     </label>
//     {textarea ? (
//       <textarea
//         className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 bg-white text-base font-medium resize-none"
//         id={name} name={name} rows={areaRows} value={value} onChange={onChange}
//         required={required} spellCheck placeholder={`Enter ${label.toLowerCase()}...`}
//       />
//     ) : (
//       <div className="relative">
//         <input
//           className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white pr-12"
//           id={name} name={name}
//           type={showPasswordToggle ? (showPassword ? "text" : "password") : inputType}
//           required={required} value={value} onChange={onChange}
//           autoComplete={showPasswordToggle || inputType === "password" ? "new-password" : "off"}
//           placeholder={`Enter ${label.toLowerCase()}${required ? " *" : ""}`}
//         />
//         {showPasswordToggle && setShowPassword && (
//           <button
//             type="button" aria-label={showPassword ? "Hide password" : "Show password"}
//             className="absolute right-4 top-1/2 transform -translate-y-1/2 text-blue-700 hover:text-black transition"
//             tabIndex={-1} onClick={() => setShowPassword((p) => !p)}
//           >
//             {showPassword ? <FaEyeSlash /> : <FaEye />}
//           </button>
//         )}
//       </div>
//     )}
//     <span className="absolute bottom-0 left-0 w-0 h-1 bg-blue-700 transition-all duration-300 group-focus-within:w-full" />
//   </div>
// );

// // --- Delete Confirm Modal
// const DeleteConfirm: React.FC<{
//   onConfirm: () => void; onCancel: () => void; loading: boolean; message?: string;
// }> = ({ onConfirm, onCancel, loading, message }) => (
//   <div className="fixed inset-0 flex items-center justify-center z-[120] bg-black/40">
//     <div className="bg-white p-7 md:p-12 rounded-lg shadow-xl border border-blue-700 relative w-full max-w-xs">
//       <div className="mb-8 text-2xl font-bold text-red-700 flex items-center gap-2">
//         <FaExclamationCircle className="text-3xl" />
//         {message || "Are you sure you want to delete?"}
//       </div>
//       <div className="flex gap-3 justify-end">
//         <button onClick={onCancel} disabled={loading} className="px-6 py-2.5 bg-white border border-blue-700 hover:bg-blue-50 rounded-lg font-bold text-black mr-2 shadow">
//           Cancel
//         </button>
//         <button onClick={onConfirm} disabled={loading} className="px-7 py-2.5 bg-red-600 text-white rounded-lg font-black shadow hover:bg-red-700 transition">
//           {loading ? <FaSpinner className="animate-spin inline" /> : "Delete"}
//         </button>
//       </div>
//     </div>
//   </div>
// );

// export default AddCompany;

import React, { useEffect, useRef, useState, ChangeEvent } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaBuilding,
  FaSpinner,
  FaTrashAlt,
  FaArrowLeft,
  FaPhoneAlt,
  FaEye,
  FaEyeSlash,
  FaLock,
  FaTimes,
  FaUniversity,
  FaPlus,
  FaEdit,
  FaSave,
} from "react-icons/fa";

// --- Config ---
const API_URL = process.env.REACT_APP_API_URL!;

// --- Worldwide Country/State/City data (top countries with states & major cities) ---
const WORLD_DATA: Record<string, Record<string, string[]>> = {
  India: {
    "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Tirupati"],
    "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Pasighat"],
    Assam: ["Guwahati", "Silchar", "Dibrugarh", "Jorhat"],
    Bihar: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur"],
    Chhattisgarh: ["Raipur", "Bhilai", "Korba", "Bilaspur"],
    Goa: ["Panaji", "Margao", "Vasco da Gama"],
    Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
    Haryana: ["Gurugram", "Faridabad", "Ambala", "Hisar"],
    "Himachal Pradesh": ["Shimla", "Manali", "Dharamsala", "Solan"],
    Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro"],
    Karnataka: ["Bengaluru", "Mysuru", "Mangaluru", "Hubballi"],
    Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur"],
    "Madhya Pradesh": ["Bhopal", "Indore", "Gwalior", "Jabalpur"],
    Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"],
    Manipur: ["Imphal", "Thoubal", "Bishnupur"],
    Meghalaya: ["Shillong", "Tura", "Jowai"],
    Mizoram: ["Aizawl", "Lunglei", "Saiha"],
    Nagaland: ["Kohima", "Dimapur", "Mokokchung"],
    Odisha: ["Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur"],
    Punjab: ["Chandigarh", "Ludhiana", "Amritsar", "Jalandhar"],
    Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
    Sikkim: ["Gangtok", "Namchi", "Gyalshing"],
    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli"],
    Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar"],
    Tripura: ["Agartala", "Udaipur", "Dharmanagar"],
    "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Noida"],
    Uttarakhand: ["Dehradun", "Haridwar", "Rishikesh", "Nainital"],
    "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Siliguri"],
    Delhi: ["New Delhi", "Dwarka", "Rohini", "Saket"],
    "Jammu & Kashmir": ["Srinagar", "Jammu", "Anantnag"],
    Ladakh: ["Leh", "Kargil"],
    Puducherry: ["Puducherry", "Karaikal", "Mahe"],
  },
  "United States": {
    Alabama: ["Birmingham", "Montgomery", "Huntsville", "Mobile"],
    Alaska: ["Anchorage", "Fairbanks", "Juneau"],
    Arizona: ["Phoenix", "Tucson", "Mesa", "Scottsdale"],
    Arkansas: ["Little Rock", "Fort Smith", "Fayetteville"],
    California: ["Los Angeles", "San Francisco", "San Diego", "San Jose", "Sacramento"],
    Colorado: ["Denver", "Colorado Springs", "Aurora", "Boulder"],
    Connecticut: ["Bridgeport", "New Haven", "Hartford", "Stamford"],
    Delaware: ["Wilmington", "Dover", "Newark"],
    Florida: ["Miami", "Orlando", "Tampa", "Jacksonville", "Tallahassee"],
    Georgia: ["Atlanta", "Augusta", "Columbus", "Savannah"],
    Hawaii: ["Honolulu", "Pearl City", "Hilo"],
    Idaho: ["Boise", "Nampa", "Meridian"],
    Illinois: ["Chicago", "Aurora", "Naperville", "Springfield"],
    Indiana: ["Indianapolis", "Fort Wayne", "Evansville"],
    Iowa: ["Des Moines", "Cedar Rapids", "Davenport"],
    Kansas: ["Wichita", "Overland Park", "Kansas City", "Topeka"],
    Kentucky: ["Louisville", "Lexington", "Bowling Green"],
    Louisiana: ["New Orleans", "Baton Rouge", "Shreveport"],
    Maine: ["Portland", "Lewiston", "Bangor"],
    Maryland: ["Baltimore", "Frederick", "Rockville", "Annapolis"],
    Massachusetts: ["Boston", "Worcester", "Springfield", "Cambridge"],
    Michigan: ["Detroit", "Grand Rapids", "Warren", "Ann Arbor"],
    Minnesota: ["Minneapolis", "Saint Paul", "Rochester"],
    Mississippi: ["Jackson", "Gulfport", "Southaven"],
    Missouri: ["Kansas City", "Saint Louis", "Springfield", "Columbia"],
    Montana: ["Billings", "Missoula", "Great Falls"],
    Nebraska: ["Omaha", "Lincoln", "Bellevue"],
    Nevada: ["Las Vegas", "Henderson", "Reno", "Carson City"],
    "New Hampshire": ["Manchester", "Nashua", "Concord"],
    "New Jersey": ["Newark", "Jersey City", "Paterson", "Trenton"],
    "New Mexico": ["Albuquerque", "Las Cruces", "Santa Fe"],
    "New York": ["New York City", "Buffalo", "Rochester", "Albany", "Syracuse"],
    "North Carolina": ["Charlotte", "Raleigh", "Greensboro", "Durham"],
    "North Dakota": ["Fargo", "Bismarck", "Grand Forks"],
    Ohio: ["Columbus", "Cleveland", "Cincinnati", "Toledo"],
    Oklahoma: ["Oklahoma City", "Tulsa", "Norman"],
    Oregon: ["Portland", "Salem", "Eugene"],
    Pennsylvania: ["Philadelphia", "Pittsburgh", "Allentown", "Erie"],
    "Rhode Island": ["Providence", "Cranston", "Warwick"],
    "South Carolina": ["Columbia", "Charleston", "Greenville"],
    "South Dakota": ["Sioux Falls", "Rapid City", "Aberdeen"],
    Tennessee: ["Nashville", "Memphis", "Knoxville", "Chattanooga"],
    Texas: ["Houston", "San Antonio", "Dallas", "Austin", "Fort Worth"],
    Utah: ["Salt Lake City", "Provo", "West Valley City"],
    Vermont: ["Burlington", "South Burlington", "Rutland"],
    Virginia: ["Virginia Beach", "Norfolk", "Chesapeake", "Richmond"],
    Washington: ["Seattle", "Spokane", "Tacoma", "Vancouver"],
    "West Virginia": ["Charleston", "Huntington", "Morgantown"],
    Wisconsin: ["Milwaukee", "Madison", "Green Bay"],
    Wyoming: ["Cheyenne", "Casper", "Laramie"],
  },
  "United Kingdom": {
    England: ["London", "Manchester", "Birmingham", "Leeds", "Liverpool", "Sheffield", "Bristol", "Newcastle"],
    Scotland: ["Edinburgh", "Glasgow", "Aberdeen", "Dundee", "Inverness"],
    Wales: ["Cardiff", "Swansea", "Newport", "Bangor"],
    "Northern Ireland": ["Belfast", "Derry", "Lisburn", "Newry"],
  },
  Canada: {
    Ontario: ["Toronto", "Ottawa", "Mississauga", "Hamilton", "Brampton"],
    Quebec: ["Montreal", "Quebec City", "Laval", "Gatineau"],
    "British Columbia": ["Vancouver", "Victoria", "Kelowna", "Surrey"],
    Alberta: ["Calgary", "Edmonton", "Red Deer", "Lethbridge"],
    Manitoba: ["Winnipeg", "Brandon", "Steinbach"],
    Saskatchewan: ["Saskatoon", "Regina", "Prince Albert"],
    "Nova Scotia": ["Halifax", "Dartmouth", "Sydney"],
    "New Brunswick": ["Moncton", "Saint John", "Fredericton"],
    "Newfoundland and Labrador": ["St. John's", "Corner Brook", "Gander"],
    "Prince Edward Island": ["Charlottetown", "Summerside"],
  },
  Australia: {
    "New South Wales": ["Sydney", "Newcastle", "Wollongong", "Canberra"],
    Victoria: ["Melbourne", "Geelong", "Ballarat", "Bendigo"],
    Queensland: ["Brisbane", "Gold Coast", "Townsville", "Cairns"],
    "Western Australia": ["Perth", "Fremantle", "Bunbury"],
    "South Australia": ["Adelaide", "Mount Gambier", "Whyalla"],
    Tasmania: ["Hobart", "Launceston", "Devonport"],
    "Northern Territory": ["Darwin", "Alice Springs"],
    "Australian Capital Territory": ["Canberra", "Queanbeyan"],
  },
  Germany: {
    Bavaria: ["Munich", "Nuremberg", "Augsburg", "Regensburg"],
    "North Rhine-Westphalia": ["Cologne", "Düsseldorf", "Dortmund", "Essen"],
    "Baden-Württemberg": ["Stuttgart", "Karlsruhe", "Mannheim", "Freiburg"],
    Berlin: ["Berlin"],
    Hamburg: ["Hamburg"],
    Hesse: ["Frankfurt", "Wiesbaden", "Kassel"],
    Saxony: ["Dresden", "Leipzig", "Chemnitz"],
    Brandenburg: ["Potsdam", "Cottbus", "Brandenburg an der Havel"],
    "Lower Saxony": ["Hannover", "Braunschweig", "Osnabrück"],
    "Rhineland-Palatinate": ["Mainz", "Ludwigshafen", "Koblenz"],
  },
  France: {
    "Île-de-France": ["Paris", "Versailles", "Boulogne-Billancourt"],
    "Auvergne-Rhône-Alpes": ["Lyon", "Grenoble", "Clermont-Ferrand", "Saint-Étienne"],
    "Provence-Alpes-Côte d'Azur": ["Marseille", "Nice", "Toulon", "Aix-en-Provence"],
    "Occitanie": ["Toulouse", "Montpellier", "Nîmes"],
    "Nouvelle-Aquitaine": ["Bordeaux", "Limoges", "Pau"],
    Bretagne: ["Rennes", "Brest", "Quimper"],
    "Pays de la Loire": ["Nantes", "Angers", "Le Mans"],
    "Grand Est": ["Strasbourg", "Reims", "Metz"],
    "Hauts-de-France": ["Lille", "Amiens", "Roubaix"],
    Normandie: ["Rouen", "Caen", "Le Havre"],
  },
  UAE: {
    "Abu Dhabi": ["Abu Dhabi", "Al Ain", "Ruwais"],
    Dubai: ["Dubai", "Jebel Ali"],
    Sharjah: ["Sharjah", "Khor Fakkan"],
    Ajman: ["Ajman"],
    "Ras Al Khaimah": ["Ras Al Khaimah"],
    Fujairah: ["Fujairah"],
    "Umm Al Quwain": ["Umm Al Quwain"],
  },
  Singapore: {
    Singapore: ["Singapore", "Jurong East", "Tampines", "Woodlands", "Punggol"],
  },
  "New Zealand": {
    Auckland: ["Auckland", "Manukau", "North Shore"],
    Wellington: ["Wellington", "Lower Hutt", "Porirua"],
    Canterbury: ["Christchurch", "Selwyn", "Waimakariri"],
    Waikato: ["Hamilton", "Cambridge", "Te Awamutu"],
    "Bay of Plenty": ["Tauranga", "Rotorua", "Whakatane"],
    Otago: ["Dunedin", "Queenstown", "Alexandra"],
  },
  "South Africa": {
    Gauteng: ["Johannesburg", "Pretoria", "Ekurhuleni"],
    "Western Cape": ["Cape Town", "Stellenbosch", "George"],
    "KwaZulu-Natal": ["Durban", "Pietermaritzburg", "Richards Bay"],
    "Eastern Cape": ["Port Elizabeth", "East London", "Mthatha"],
    Limpopo: ["Polokwane", "Tzaneen", "Thohoyandou"],
  },
  Brazil: {
    "São Paulo": ["São Paulo", "Campinas", "Guarulhos", "Santos"],
    "Rio de Janeiro": ["Rio de Janeiro", "Niterói", "Nova Iguaçu"],
    "Minas Gerais": ["Belo Horizonte", "Uberlândia", "Contagem"],
    Bahia: ["Salvador", "Feira de Santana", "Vitória da Conquista"],
    Paraná: ["Curitiba", "Londrina", "Maringá"],
    "Rio Grande do Sul": ["Porto Alegre", "Caxias do Sul", "Pelotas"],
  },
  China: {
    Beijing: ["Beijing"],
    Shanghai: ["Shanghai"],
    Guangdong: ["Guangzhou", "Shenzhen", "Dongguan", "Foshan"],
    Zhejiang: ["Hangzhou", "Ningbo", "Wenzhou"],
    Jiangsu: ["Nanjing", "Suzhou", "Wuxi"],
    Sichuan: ["Chengdu", "Mianyang", "Deyang"],
    Hubei: ["Wuhan", "Yichang", "Xiangyang"],
    Shandong: ["Jinan", "Qingdao", "Yantai"],
  },
  Japan: {
    Tokyo: ["Tokyo", "Shinjuku", "Shibuya", "Harajuku"],
    Osaka: ["Osaka", "Sakai", "Suita"],
    Kanagawa: ["Yokohama", "Kawasaki", "Sagamihara"],
    Aichi: ["Nagoya", "Toyota", "Anjo"],
    Hokkaido: ["Sapporo", "Asahikawa", "Hakodate"],
    Kyoto: ["Kyoto", "Uji", "Nagaokakyo"],
    Fukuoka: ["Fukuoka", "Kitakyushu", "Kurume"],
  },
};

const COUNTRIES = Object.keys(WORLD_DATA).sort();

const ACCOUNT_TYPES = ["Savings", "Current", "Overdraft", "Cash Credit", "Fixed Deposit", "NRI"];

// --- State & Field Configs
const initialCompanyState = {
  company_name: "",
  address: "",
  pancard: "",
  city: "",
  state: "",
  country: "",
  gst_number: "",
  gst_uin: "",
  code: "",
  cin: "",
  email: "",
  password: "",
  phone: "",
  HSN_SAC: "[]",
  GST_SLAB: "[]",
  signature: "",
  prefix: "",
  postfix: "",
  separatorsign: "",
};

const initialBankState = {
  bank_name: "",
  branch: "",
  account_number: "",
  ifsc_code: "",
  micr_code: "",
  swift_code: "",
  account_type: "",
  account_holder_name: "",
};

type CompanyType = typeof initialCompanyState & { id?: string | number; bank_id?: string | number };
type BankType = typeof initialBankState & { id?: string | number; company_id?: string | number };

// --- Hidden field defaults (sent to API but not shown in UI)
const HIDDEN_DEFAULTS = {
  password: "",
  gst_uin: "",
  code: "",
  cin: "",
  prefix: "",
  postfix: "",
  separatorsign: "/",
  HSN_SAC: "[]",
  GST_SLAB: "[]",
};

// ✅ Helper: coerce null / undefined / "null" / "undefined" to empty string
const sanitize = (value: unknown, fallback = ""): string => {
  if (value === null || value === undefined) return fallback;
  const str = String(value);
  if (str === "null" || str === "undefined") return fallback;
  return str;
};

// --- Visible field groups
const visibleFieldGroups: Array<{
  title?: string;
  icon?: any;
  cols?: string;
  fields: Array<any>;
}> = [
  {
    title: "Basic Info",
    icon: FaBuilding,
    cols: "md:grid-cols-2",
    fields: [
      {
        label: "Company Name",
        name: "company_name",
        required: true,
        icon: <FaBuilding className="inline mr-2 text-blue-700" />,
      },
      { label: "Address", name: "address", textarea: true, areaRows: 3, gridFull: true },
      { label: "Email", name: "email", inputType: "email" },
      {
        label: "Phone Number",
        name: "phone",
        inputType: "tel",
        icon: <FaPhoneAlt className="inline text-blue-700 mr-2" />,
      },
    ],
  },
  {
    title: "Registration",
    cols: "md:grid-cols-2",
    fields: [
      { label: "PAN", name: "pancard" },
      { label: "GST Number", name: "gst_number" },
    ],
  },
];

// --- AddCompany Component
const AddCompany: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const companyId = searchParams.get("company_id");
  const isEditMode = companyId && companyId !== "new";

  const [company, setCompany] = useState<CompanyType>(initialCompanyState);
  const [signatureFile, setSignatureFile] = useState<File | null>(null);
  const [signaturePreview, setSignaturePreview] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [error, setError] = useState<string>("");
  const [formError, setFormError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  // Location cascade
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  // --- Bank Details State ---
  const [bankDetails, setBankDetails] = useState<BankType[]>([]);
  const [bankLoading, setBankLoading] = useState(false);
  const [showBankForm, setShowBankForm] = useState(false);
  const [bankForm, setBankForm] = useState<BankType>(initialBankState);
  const [editingBankId, setEditingBankId] = useState<string | number | null>(null);
  const [bankSubmitting, setBankSubmitting] = useState(false);
  const [bankError, setBankError] = useState<string>("");
  const [bankSuccess, setBankSuccess] = useState<string>("");
  const [deleteBankId, setDeleteBankId] = useState<string | number | null>(null);
  const [deleteBankLoading, setDeleteBankLoading] = useState(false);

  const availableStates = selectedCountry ? Object.keys(WORLD_DATA[selectedCountry] || {}).sort() : [];
  const availableCities = selectedCountry && selectedState ? (WORLD_DATA[selectedCountry]?.[selectedState] || []).sort() : [];

  const alertRef = useRef<HTMLDivElement>(null);
  const bankAlertRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (error || formError || success) alertRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [error, formError, success]);

  useEffect(() => {
    if (bankError || bankSuccess) bankAlertRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [bankError, bankSuccess]);

  // --- Fetch company for edit mode
  useEffect(() => {
    if (isEditMode && companyId) {
      setLoading(true);
      axios.get(`${API_URL}/companyAuth/company/${companyId}`)
        .then((res) => {
          const data = res.data;
          const sanitized: CompanyType = {
            ...initialCompanyState,
            company_name:   sanitize(data.company_name),
            address:        sanitize(data.address),
            pancard:        sanitize(data.pancard),
            city:           sanitize(data.city),
            state:          sanitize(data.state),
            country:        sanitize(data.country),
            gst_number:     sanitize(data.gst_number),
            gst_uin:        sanitize(data.gst_uin,        HIDDEN_DEFAULTS.gst_uin),
            code:           sanitize(data.code,           HIDDEN_DEFAULTS.code),
            cin:            sanitize(data.cin,            HIDDEN_DEFAULTS.cin),
            email:          sanitize(data.email),
            password:       sanitize(data.password,       HIDDEN_DEFAULTS.password),
            phone:          sanitize(data.phone),
            HSN_SAC:        sanitize(data.HSN_SAC,        HIDDEN_DEFAULTS.HSN_SAC),
            GST_SLAB:       sanitize(data.GST_SLAB,       HIDDEN_DEFAULTS.GST_SLAB),
            signature:      sanitize(data.signature),
            prefix:         sanitize(data.prefix,         HIDDEN_DEFAULTS.prefix),
            postfix:        sanitize(data.postfix,        HIDDEN_DEFAULTS.postfix),
            separatorsign:  sanitize(data.separatorsign,  HIDDEN_DEFAULTS.separatorsign),
            id:             data.id,
            bank_id:        data.bank_id,
          };
          setCompany(sanitized);
          setSelectedCountry(sanitized.country);
          setSelectedState(sanitized.state);
          setSelectedCity(sanitized.city);
          if (sanitized.signature) {
            let url = sanitized.signature;
            if (!url.startsWith("http") && !url.startsWith("data:")) {
              if (url.startsWith("/")) url = url.substring(1);
              const apiBase = (API_URL || "").replace(/\/$/, "");
              setSignaturePreview(`${apiBase}/${url}`);
            } else {
              setSignaturePreview(url);
            }
          }
          setSignatureFile(null);
        })
        .catch(() => setError("Unable to load company details."))
        .finally(() => setLoading(false));

      // Fetch bank details for this company
      fetchBankDetails(companyId);
    } else {
      setCompany(initialCompanyState);
      setSelectedCountry("");
      setSelectedState("");
      setSelectedCity("");
      setSignaturePreview("");
      setSignatureFile(null);
      setBankDetails([]);
    }
    // eslint-disable-next-line
  }, [companyId, isEditMode]);

  const fetchBankDetails = (cid: string) => {
    setBankLoading(true);
    axios.get(`${API_URL}/companyAuth/company/${cid}/bank`)
      .then((res) => setBankDetails(res.data || []))
      .catch(() => setBankDetails([]))
      .finally(() => setBankLoading(false));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setCompany((prev) => ({ ...prev, [name]: value }));
  };

  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    setSelectedCountry(val);
    setSelectedState("");
    setSelectedCity("");
    setCompany((prev) => ({ ...prev, country: val, state: "", city: "" }));
  };

  const handleStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    setSelectedState(val);
    setSelectedCity("");
    setCompany((prev) => ({ ...prev, state: val, city: "" }));
  };

  const handleCityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    setSelectedCity(val);
    setCompany((prev) => ({ ...prev, city: val }));
  };

  const handleSignatureChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (!file.type.match(/^image\/(png|jpeg|jpg|webp|svg\+xml)$/)) {
      setFormError("Please upload an image file (png, jpg, jpeg, svg, webp).");
      return;
    }
    setSignatureFile(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result && typeof reader.result === "string") setSignaturePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const clearSignature = () => { setSignaturePreview(""); setSignatureFile(null); };

  const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhone = (phone: string) => /^(\+?\d{1,4}[\s-]?)?\d{10}$/.test(phone);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormError(""); setSuccess("");

    if (!company.company_name.trim()) { setFormError("Company name is required."); return; }
    if (company.email && !validateEmail(company.email)) { setFormError("Invalid email address."); return; }
    if (company.phone && !validatePhone(company.phone)) { setFormError("Invalid phone number."); return; }

    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("company_name", sanitize(company.company_name));
      formData.append("address",      sanitize(company.address));
      formData.append("pancard",      sanitize(company.pancard));
      formData.append("city",         sanitize(selectedCity    || company.city));
      formData.append("state",        sanitize(selectedState   || company.state));
      formData.append("country",      sanitize(selectedCountry || company.country));
      formData.append("gst_number",   sanitize(company.gst_number));
      formData.append("email",        sanitize(company.email));
      formData.append("phone",        sanitize(company.phone));
      if (signatureFile) formData.append("signature", signatureFile);
      formData.append("password",      sanitize(company.password,      HIDDEN_DEFAULTS.password));
      formData.append("gst_uin",       sanitize(company.gst_uin,       HIDDEN_DEFAULTS.gst_uin));
      formData.append("code",          sanitize(company.code,          HIDDEN_DEFAULTS.code));
      formData.append("cin",           sanitize(company.cin,           HIDDEN_DEFAULTS.cin));
      formData.append("prefix",        sanitize(company.prefix,        HIDDEN_DEFAULTS.prefix));
      formData.append("postfix",       sanitize(company.postfix,       HIDDEN_DEFAULTS.postfix));
      formData.append("separatorsign", sanitize(company.separatorsign, HIDDEN_DEFAULTS.separatorsign));
      formData.append("HSN_SAC",       sanitize(company.HSN_SAC,       HIDDEN_DEFAULTS.HSN_SAC));

      if (isEditMode && companyId) {
        const response = await axios.put(
          `${API_URL}/companyAuth/company/${companyId}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        setSuccess("Company updated successfully!");
        if (response.data.signature) {
          let url = sanitize(response.data.signature);
          if (url && !url.startsWith("http") && !url.startsWith("data:")) {
            if (url.startsWith("/")) url = url.substring(1);
            const apiBase = (API_URL || "").replace(/\/$/, "");
            setSignaturePreview(`${apiBase}/${url}`);
          } else setSignaturePreview(url);
        }
      } else {
        // try {
        //   await axios.post(`${API_URL}/companyAuth/register`, {
        //     name:     sanitize(company.company_name),
        //     email:    sanitize(company.email),
        //     password: sanitize(company.password, HIDDEN_DEFAULTS.password),
        //     phone:    sanitize(company.phone),
        //     role: "company",
        //   }, { headers: { "Content-Type": "application/json" } });
        // } catch (err: any) {
        //   setFormError(err.response?.data?.message ? "Registration failed: " + err.response.data.message : "User registration failed");
        //   setSubmitting(false);
        //   return;
        // }
        await axios.post(`${API_URL}/companyAuth/company`, formData, { headers: { "Content-Type": "multipart/form-data" } });
        setSuccess("Company added successfully!");
        setCompany(initialCompanyState);
        setSelectedCountry(""); setSelectedState(""); setSelectedCity("");
        setSignaturePreview(""); setSignatureFile(null);
      }
      setTimeout(() => navigate("/admin/company"), 1200);
    } catch (err: any) {
      if (err.response?.data?.error) setFormError(err.response.data.error);
      else setFormError("Failed to save company.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    if (!isEditMode || !companyId) return;
    setDeleteLoading(true); setError("");
    try {
      await axios.delete(`${API_URL}/companyAuth/company/${companyId}`);
      setSuccess("Deleted successfully!");
      setTimeout(() => navigate("/admin/company"), 900);
    } catch { setError("Failed to delete company."); }
    finally { setDeleteLoading(false); setShowDeleteConfirm(false); }
  };

  // --- Bank Handlers ---
  const handleBankInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setBankForm((prev) => ({ ...prev, [name]: value }));
  };

  const openAddBankForm = () => {
    setBankForm(initialBankState);
    setEditingBankId(null);
    setBankError("");
    setBankSuccess("");
    setShowBankForm(true);
  };

  const openEditBankForm = (bank: BankType) => {
    setBankForm({ ...bank });
    setEditingBankId(bank.id ?? null);
    setBankError("");
    setBankSuccess("");
    setShowBankForm(true);
  };

  const closeBankForm = () => {
    setShowBankForm(false);
    setBankForm(initialBankState);
    setEditingBankId(null);
    setBankError("");
  };

  const handleBankSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBankError(""); setBankSuccess("");
    if (!bankForm.bank_name.trim()) { setBankError("Bank name is required."); return; }
    if (!bankForm.account_number.trim()) { setBankError("Account number is required."); return; }

    setBankSubmitting(true);
    try {
      if (editingBankId) {
        await axios.put(`${API_URL}/companyAuth/bank/${editingBankId}`, bankForm);
        setBankSuccess("Bank details updated successfully!");
      } else {
        await axios.post(`${API_URL}/companyAuth/company/${companyId}/bank`, bankForm);
        setBankSuccess("Bank details added successfully!");
      }
      if (companyId) fetchBankDetails(companyId);
      setTimeout(() => { closeBankForm(); setBankSuccess(""); }, 1000);
    } catch (err: any) {
      setBankError(err.response?.data?.error || "Failed to save bank details.");
    } finally {
      setBankSubmitting(false);
    }
  };

  const handleBankDelete = async () => {
    if (!deleteBankId) return;
    setDeleteBankLoading(true);
    try {
      await axios.delete(`${API_URL}/companyAuth/bank/${deleteBankId}`);
      setBankSuccess("Bank details deleted.");
      if (companyId) fetchBankDetails(companyId);
    } catch {
      setBankError("Failed to delete bank details.");
    } finally {
      setDeleteBankLoading(false);
      setDeleteBankId(null);
    }
  };

  return (
    <div className="bg-white w-full max-w-full 2xl:max-w-[1440px] mx-auto shadow-xl rounded-xl p-4 mt-12 border border-blue-700" style={{ minHeight: "600px" }}>
      {/* HEADER */}
      <div className="py-6 px-4 md:px-10 flex flex-col sm:flex-row justify-between items-center">
        <div className="flex items-center gap-4">
          <span className="inline-flex rounded-full bg-blue-100 p-4 shadow">
            <FaBuilding className="text-blue-700 text-4xl" />
          </span>
          <div>
            <h2 className="text-3xl font-extrabold text-black leading-tight tracking-tight">
              {isEditMode ? "Edit Company" : "Add Company"}
            </h2>
            <div className="mb-0 text-gray-600 font-medium text-base pt-1 ml-2">
              Add or modify your company profile.
            </div>
          </div>
        </div>
      </div>

      {/* ALERTS */}
      <div className="px-4 md:px-10" ref={alertRef}>
        {error && <Alert type="error" message={error} />}
        {formError && <Alert type="error" message={formError} />}
        {success && <Alert type="success" message={success} />}
      </div>

      {/* FORM CARD */}
      <div className="flex justify-center py-6 pb-16">
        <div className="w-full bg-white border border-blue-700 px-4 pt-8 pb-12 md:px-10 md:py-14 rounded-xl shadow-xl relative max-w-full">
          {loading ? (
            <div className="flex justify-center items-center text-blue-700 font-semibold animate-pulse py-10 text-lg">
              <FaSpinner className="animate-spin mr-3 text-2xl" /> Loading company...
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col gap-10" autoComplete="off">

              {/* VISIBLE FIELD GROUPS */}
              {visibleFieldGroups.map((group, idx) => (
                <fieldset key={idx} className="rounded-lg px-2 py-4 border border-blue-200 bg-white mb-2">
                  {group.title && (
                    <legend className="font-semibold text-xl mb-4 text-blue-900 flex items-center gap-2 px-2">
                      {group.icon && <group.icon />}
                      <span>{group.title}</span>
                    </legend>
                  )}
                  <div className={`grid grid-cols-1 ${group.cols || ""} gap-x-8 gap-y-5`}>
                    {group.fields.map((fld: any) => (
                      <div key={fld.name} className={fld.gridFull ? "col-span-full" : ""}>
                        <FormField
                          label={fld.label}
                          name={fld.name}
                          required={fld.required}
                          value={company[fld.name as keyof typeof initialCompanyState] as string}
                          onChange={handleInputChange}
                          textarea={fld.textarea}
                          areaRows={fld.areaRows}
                          inputType={fld.inputType}
                          icon={fld.icon}
                        />
                      </div>
                    ))}
                  </div>
                </fieldset>
              ))}

              {/* LOCATION */}
              <fieldset className="rounded-lg px-2 py-4 border border-blue-200 bg-white mb-2">
                <legend className="font-semibold text-xl mb-4 text-blue-900 px-2">Location</legend>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-5">
                  <div className="flex flex-col">
                    <label className="block font-bold mb-2 text-blue-900 text-lg" htmlFor="country-select">Country</label>
                    <select
                      id="country-select"
                      className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white"
                      value={selectedCountry}
                      onChange={handleCountryChange}
                    >
                      <option value="">Select Country</option>
                      {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  <div className="flex flex-col">
                    <label className="block font-bold mb-2 text-blue-900 text-lg" htmlFor="state-select">State / Province</label>
                    <select
                      id="state-select"
                      className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white disabled:opacity-50"
                      value={selectedState}
                      onChange={handleStateChange}
                      disabled={!selectedCountry}
                    >
                      <option value="">{selectedCountry ? "Select State" : "Select Country first"}</option>
                      {availableStates.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>
                  <div className="flex flex-col">
                    <label className="block font-bold mb-2 text-blue-900 text-lg" htmlFor="city-select">City</label>
                    <select
                      id="city-select"
                      className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white disabled:opacity-50"
                      value={selectedCity}
                      onChange={handleCityChange}
                      disabled={!selectedState}
                    >
                      <option value="">{selectedState ? "Select City" : "Select State first"}</option>
                      {availableCities.map((c) => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                </div>
              </fieldset>

              {/* SIGNATURE UPLOAD */}
              <fieldset className="rounded-lg px-2 py-3 border border-blue-200 bg-white mb-2">
                <legend className="font-semibold text-base mb-2 text-blue-700 flex items-center gap-2 px-2 border-0">
                  Signature
                </legend>
                <div className="flex flex-col sm:flex-row gap-4 items-center">
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml"
                    id="signature"
                    name="signature"
                    onChange={handleSignatureChange}
                    className="block w-full sm:w-auto text-sm file:mr-4 file:py-2 file:px-5 file:rounded-lg file:border-0 file:text-md file:font-semibold file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200 shadow"
                  />
                  {signaturePreview ? (
                    <div className="flex flex-row items-center gap-3">
                      <img src={signaturePreview} alt="Signature" className="h-16 w-auto border-2 border-blue-200 bg-white rounded-lg shadow" />
                      <button
                        type="button"
                        aria-label="Remove signature"
                        className="ml-1 text-red-600 hover:bg-red-100 border border-red-300 px-3 py-2 rounded-md font-semibold shadow-md"
                        onClick={clearSignature}
                      >
                        <FaTimes className="inline" /> <span className="sr-only md:not-sr-only">Remove</span>
                      </button>
                    </div>
                  ) : (
                    <div className="text-xs text-gray-600 mt-1 pl-0.5 font-medium italic">
                      Upload your company's authorized signature image (jpg, jpeg, png, svg, webp).
                    </div>
                  )}
                </div>
              </fieldset>

              {/* CTA BUTTONS */}
              <div className="flex flex-wrap gap-4 pt-6 justify-between items-center">
                <button
                  type="submit"
                  className="flex items-center gap-3 px-10 py-4 rounded-lg shadow-xl font-black bg-blue-700 text-white text-xl transition active:scale-95 hover:ring-2 hover:ring-blue-300 focus:outline-none"
                  disabled={submitting}
                >
                  {submitting && <FaSpinner className="animate-spin inline" />}
                  {isEditMode
                    ? submitting ? "Updating..." : "Update Company"
                    : submitting ? "Adding..." : "Add Company"}
                </button>
                <button
                  type="button"
                  className="bg-white px-8 py-3 rounded-lg border border-blue-700 hover:bg-blue-50 font-bold text-lg text-black transition flex items-center gap-3 shadow"
                  onClick={() => navigate("/admin/company")}
                  disabled={submitting || deleteLoading}
                >
                  <FaArrowLeft className="text-blue-700" /> Cancel
                </button>
                {isEditMode && (
                  <button
                    type="button"
                    className="ml-auto flex items-center px-8 py-3 bg-red-600 text-white rounded-lg font-bold text-lg shadow-xl hover:bg-red-700 transition gap-3"
                    onClick={() => setShowDeleteConfirm(true)}
                    disabled={deleteLoading}
                  >
                    <FaTrashAlt />
                    {deleteLoading ? "Deleting..." : "Delete"}
                  </button>
                )}
              </div>
            </form>
          )}

          {/* ==============================
              BANK DETAILS SECTION
              Only shown in edit mode (company must exist first)
          ============================== */}
          {isEditMode && (
            <div className="mt-12">
              <div ref={bankAlertRef}>
                {bankError && <Alert type="error" message={bankError} />}
                {bankSuccess && !showBankForm && <Alert type="success" message={bankSuccess} />}
              </div>

              <fieldset className="rounded-lg px-2 py-4 border border-blue-200 bg-white">
                <legend className="font-semibold text-xl text-blue-900 flex items-center gap-2 px-2">
                  <FaUniversity className="text-blue-700" />
                  <span>Bank Details</span>
                </legend>

                {/* Bank list */}
                {bankLoading ? (
                  <div className="flex items-center gap-3 text-blue-700 py-6 font-semibold animate-pulse">
                    <FaSpinner className="animate-spin text-xl" /> Loading bank details...
                  </div>
                ) : bankDetails.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4 mb-6">
                    {bankDetails.map((bank) => (
                      <BankCard
                        key={bank.id}
                        bank={bank}
                        onEdit={() => openEditBankForm(bank)}
                        onDelete={() => setDeleteBankId(bank.id ?? null)}
                      />
                    ))}
                  </div>
                ) : (
                  !showBankForm && (
                    <div className="text-gray-500 italic text-base mt-4 mb-6 pl-1">
                      No bank accounts added yet. Click "Add Bank Account" to get started.
                    </div>
                  )
                )}

                {/* Inline bank form */}
                {showBankForm && (
                  <div className="border border-blue-300 rounded-xl bg-blue-50 px-5 py-6 mb-6 shadow-inner">
                    <div className="flex items-center justify-between mb-5">
                      <h3 className="font-bold text-blue-900 text-lg flex items-center gap-2">
                        <FaUniversity className="text-blue-700" />
                        {editingBankId ? "Edit Bank Account" : "New Bank Account"}
                      </h3>
                      <button
                        type="button"
                        onClick={closeBankForm}
                        className="text-gray-500 hover:text-red-600 transition p-1"
                        aria-label="Close bank form"
                      >
                        <FaTimes className="text-xl" />
                      </button>
                    </div>

                    {bankError && <Alert type="error" message={bankError} />}
                    {bankSuccess && <Alert type="success" message={bankSuccess} />}

                    <form onSubmit={handleBankSubmit} autoComplete="off">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5">
                        {/* Bank Name */}
                        <BankFormField
                          label="Bank Name"
                          name="bank_name"
                          value={bankForm.bank_name}
                          onChange={handleBankInputChange}
                          required
                          placeholder="e.g. State Bank of India"
                        />
                        {/* Account Holder Name */}
                        <BankFormField
                          label="Account Holder Name"
                          name="account_holder_name"
                          value={bankForm.account_holder_name}
                          onChange={handleBankInputChange}
                          placeholder="e.g. Acme Pvt. Ltd."
                        />
                        {/* Account Number */}
                        <BankFormField
                          label="Account Number"
                          name="account_number"
                          value={bankForm.account_number}
                          onChange={handleBankInputChange}
                          required
                          placeholder="e.g. 00112233445566"
                        />
                        {/* Account Type */}
                        <div className="flex flex-col">
                          <label className="block font-bold mb-2 text-blue-900 text-lg" htmlFor="bank-account-type">
                            Account Type
                          </label>
                          <select
                            id="bank-account-type"
                            name="account_type"
                            value={bankForm.account_type}
                            onChange={handleBankInputChange}
                            className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white"
                          >
                            <option value="">Select account type</option>
                            {ACCOUNT_TYPES.map((t) => (
                              <option key={t} value={t}>{t}</option>
                            ))}
                          </select>
                        </div>
                        {/* Branch */}
                        <BankFormField
                          label="Branch"
                          name="branch"
                          value={bankForm.branch}
                          onChange={handleBankInputChange}
                          placeholder="e.g. Connaught Place, New Delhi"
                        />
                        {/* IFSC Code */}
                        <BankFormField
                          label="IFSC Code"
                          name="ifsc_code"
                          value={bankForm.ifsc_code}
                          onChange={handleBankInputChange}
                          placeholder="e.g. SBIN0001234"
                        />
                        {/* MICR Code */}
                        <BankFormField
                          label="MICR Code"
                          name="micr_code"
                          value={bankForm.micr_code}
                          onChange={handleBankInputChange}
                          placeholder="e.g. 110002003"
                        />
                        {/* SWIFT Code */}
                        <BankFormField
                          label="SWIFT / BIC Code"
                          name="swift_code"
                          value={bankForm.swift_code}
                          onChange={handleBankInputChange}
                          placeholder="e.g. SBININBB"
                        />
                      </div>

                      <div className="flex gap-4 mt-7">
                        <button
                          type="submit"
                          disabled={bankSubmitting}
                          className="flex items-center gap-2 px-8 py-3 bg-blue-700 text-white rounded-lg font-bold text-base shadow-lg hover:bg-blue-800 transition active:scale-95"
                        >
                          {bankSubmitting
                            ? <><FaSpinner className="animate-spin" /> Saving...</>
                            : <><FaSave /> {editingBankId ? "Update Bank" : "Save Bank"}</>
                          }
                        </button>
                        <button
                          type="button"
                          onClick={closeBankForm}
                          disabled={bankSubmitting}
                          className="px-7 py-3 border border-blue-700 rounded-lg font-bold text-base text-black bg-white hover:bg-blue-50 transition shadow"
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {/* Add Bank Button */}
                {!showBankForm && (
                  <button
                    type="button"
                    onClick={openAddBankForm}
                    className="flex items-center gap-2 px-7 py-3 bg-blue-700 text-white rounded-lg font-bold text-base shadow-lg hover:bg-blue-800 transition active:scale-95 mt-2"
                  >
                    <FaPlus /> Add Bank Account
                  </button>
                )}
              </fieldset>
            </div>
          )}
        </div>
      </div>

      {/* DELETE COMPANY CONFIRM MODAL */}
      {showDeleteConfirm && (
        <DeleteConfirm
          onConfirm={handleDelete}
          onCancel={() => setShowDeleteConfirm(false)}
          loading={deleteLoading}
          message="Are you sure you want to delete this company?"
        />
      )}

      {/* DELETE BANK CONFIRM MODAL */}
      {deleteBankId !== null && (
        <DeleteConfirm
          onConfirm={handleBankDelete}
          onCancel={() => setDeleteBankId(null)}
          loading={deleteBankLoading}
          message="Delete this bank account?"
        />
      )}
    </div>
  );
};

// --- BankCard Component
const BankCard: React.FC<{
  bank: BankType;
  onEdit: () => void;
  onDelete: () => void;
}> = ({ bank, onEdit, onDelete }) => (
  <div className="border border-blue-200 rounded-xl bg-white shadow p-5 flex flex-col gap-3 relative group hover:border-blue-400 transition">
    <div className="flex items-start justify-between">
      <div className="flex items-center gap-3">
        <span className="inline-flex rounded-full bg-blue-100 p-2">
          <FaUniversity className="text-blue-700 text-lg" />
        </span>
        <div>
          <div className="font-extrabold text-blue-900 text-base leading-tight">{bank.bank_name}</div>
          {bank.account_holder_name && (
            <div className="text-gray-500 text-sm font-medium">{bank.account_holder_name}</div>
          )}
        </div>
      </div>
      <div className="flex gap-2 ml-2">
        <button
          type="button"
          onClick={onEdit}
          className="p-2 rounded-lg border border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100 transition shadow-sm"
          aria-label="Edit bank"
          title="Edit"
        >
          <FaEdit />
        </button>
        <button
          type="button"
          onClick={onDelete}
          className="p-2 rounded-lg border border-red-200 bg-red-50 text-red-600 hover:bg-red-100 transition shadow-sm"
          aria-label="Delete bank"
          title="Delete"
        >
          <FaTrashAlt />
        </button>
      </div>
    </div>

    <div className="grid grid-cols-2 gap-x-4 gap-y-1 mt-1 text-sm">
      {bank.account_number && (
        <BankDetailRow label="Account No." value={bank.account_number} />
      )}
      {bank.account_type && (
        <BankDetailRow label="Type" value={bank.account_type} />
      )}
      {bank.branch && (
        <BankDetailRow label="Branch" value={bank.branch} />
      )}
      {bank.ifsc_code && (
        <BankDetailRow label="IFSC" value={bank.ifsc_code} />
      )}
      {bank.micr_code && (
        <BankDetailRow label="MICR" value={bank.micr_code} />
      )}
      {bank.swift_code && (
        <BankDetailRow label="SWIFT" value={bank.swift_code} />
      )}
    </div>
  </div>
);

const BankDetailRow: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className="flex flex-col">
    <span className="text-gray-400 font-semibold text-xs uppercase tracking-wide">{label}</span>
    <span className="text-gray-800 font-medium break-all">{value}</span>
  </div>
);

// --- BankFormField Component
interface BankFormFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  placeholder?: string;
}
const BankFormField: React.FC<BankFormFieldProps> = ({ label, name, value, onChange, required = false, placeholder }) => (
  <div className="flex flex-col relative group">
    <label className="block font-bold mb-2 text-blue-900 text-lg tracking-tight" htmlFor={`bank-${name}`}>
      {label}{required && <span className="text-red-700 ml-1">*</span>}
    </label>
    <input
      id={`bank-${name}`}
      name={name}
      type="text"
      value={value}
      onChange={onChange}
      required={required}
      placeholder={placeholder || `Enter ${label.toLowerCase()}`}
      className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white"
      autoComplete="off"
    />
    <span className="absolute bottom-0 left-0 w-0 h-1 bg-blue-700 transition-all duration-300 group-focus-within:w-full" />
  </div>
);

// --- Alert Component
const Alert: React.FC<{ type: "success" | "error"; message: string }> = ({ type, message }) => {
  const icon = type === "success"
    ? <FaCheckCircle className="mr-2 text-blue-700 text-lg" />
    : <FaExclamationCircle className="mr-2 text-red-600 text-lg" />;
  const color = type === "success"
    ? "bg-blue-100 text-blue-700 border border-blue-300"
    : "bg-red-100 text-red-700 border border-red-300";
  return (
    <div className={`mb-4 rounded-lg px-5 py-3 flex items-center shadow font-bold ${color}`}>
      {icon}{message}
    </div>
  );
};

// --- FormField Component
interface FormFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  textarea?: boolean;
  areaRows?: number;
  inputType?: string;
  required?: boolean;
  icon?: React.ReactNode;
  showPasswordToggle?: boolean;
  showPassword?: boolean;
  setShowPassword?: React.Dispatch<React.SetStateAction<boolean>>;
}

const FormField: React.FC<FormFieldProps> = ({
  label, name, value, onChange,
  textarea = false, areaRows = 2,
  inputType = "text", required = false,
  icon = null, showPasswordToggle, showPassword, setShowPassword,
}) => (
  <div className="flex flex-col relative group">
    <label className="block font-bold mb-2 text-blue-900 flex items-center gap-2 text-lg tracking-tight" htmlFor={name}>
      {icon}{label}{required && <span className="text-red-700 ml-1">*</span>}
    </label>
    {textarea ? (
      <textarea
        className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 bg-white text-base font-medium resize-none"
        id={name} name={name} rows={areaRows} value={value} onChange={onChange}
        required={required} spellCheck placeholder={`Enter ${label.toLowerCase()}...`}
      />
    ) : (
      <div className="relative">
        <input
          className="w-full p-4 border border-blue-300 rounded-lg shadow focus:outline-none focus:border-blue-700 text-base font-medium bg-white pr-12"
          id={name} name={name}
          type={showPasswordToggle ? (showPassword ? "text" : "password") : inputType}
          required={required} value={value} onChange={onChange}
          autoComplete={showPasswordToggle || inputType === "password" ? "new-password" : "off"}
          placeholder={`Enter ${label.toLowerCase()}${required ? " *" : ""}`}
        />
        {showPasswordToggle && setShowPassword && (
          <button
            type="button" aria-label={showPassword ? "Hide password" : "Show password"}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-blue-700 hover:text-black transition"
            tabIndex={-1} onClick={() => setShowPassword((p) => !p)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        )}
      </div>
    )}
    <span className="absolute bottom-0 left-0 w-0 h-1 bg-blue-700 transition-all duration-300 group-focus-within:w-full" />
  </div>
);

// --- Delete Confirm Modal
const DeleteConfirm: React.FC<{
  onConfirm: () => void; onCancel: () => void; loading: boolean; message?: string;
}> = ({ onConfirm, onCancel, loading, message }) => (
  <div className="fixed inset-0 flex items-center justify-center z-[120] bg-black/40">
    <div className="bg-white p-7 md:p-12 rounded-lg shadow-xl border border-blue-700 relative w-full max-w-xs">
      <div className="mb-8 text-2xl font-bold text-red-700 flex items-center gap-2">
        <FaExclamationCircle className="text-3xl" />
        {message || "Are you sure you want to delete?"}
      </div>
      <div className="flex gap-3 justify-end">
        <button onClick={onCancel} disabled={loading} className="px-6 py-2.5 bg-white border border-blue-700 hover:bg-blue-50 rounded-lg font-bold text-black mr-2 shadow">
          Cancel
        </button>
        <button onClick={onConfirm} disabled={loading} className="px-7 py-2.5 bg-red-600 text-white rounded-lg font-black shadow hover:bg-red-700 transition">
          {loading ? <FaSpinner className="animate-spin inline" /> : "Delete"}
        </button>
      </div>
    </div>
  </div>
);

export default AddCompany;